<template>
  <div class="page-wrap" :class="{ night, compact: isPk10Quick, 'drawer-open': playSheet, 'p3p5-page': isP3p5, 'bet-lf-page': !isPk10 }" :key="game.id">
    <div class="page-main" @click="closeDrawerIfOpen">
    <AppHeader />

    <section class="issue-block">
      <div class="issue-row" :class="{ pk10: isPk10 }">
        <button class="issue-main" type="button" @click="historyOpen = !historyOpen">
          <span class="issue-no">{{ lastIssue }}期</span>
          <div v-if="!pk10ResultAttr" class="balls" :class="{ pk10: isPk10 }">
            <span
              v-for="(n, i) in lastCodes"
              :key="i"
              class="draw-ball"
              :class="ballClass(i)"
              :style="ballStyle(n)"
            >{{ formatBall(n) }}</span>
            <span v-if="lastDrawSum != null" class="draw-sum">{{ lastDrawSum }}</span>
            <span v-if="lastDrawShape" class="draw-shape">{{ currentPlayKey === 'p3-1d'|| currentPlayKey === 'p3-2d' ? '' : lastDrawShape }}</span>
          </div>
          <div v-else class="attr-row">
            <span
              v-for="(tag, i) in pk10Attrs"
              :key="i"
              class="attr-chip"
              :class="tag.type"
            >{{ tag.text }}</span>
          </div>
        </button>
        <button v-if="isPk10" class="issue-swap" type="button" aria-label="切换盘面" @click="togglePk10View">
          <svg viewBox="0 0 24 24">
            <path d="M7 7h11.5M15.5 4.5 18.5 7l-3 2.5M17 17H5.5M8.5 14.5 5.5 17l3 2.5" fill="none" stroke="#c0c0c0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
        <button class="issue-caret" :class="{ open: historyOpen }" type="button" aria-label="历史开奖" @click="historyOpen = !historyOpen">
          <img :src="historyDownIcon" alt="" />
        </button>
      </div>
      <div class="count-row">
        <button class="game-name" type="button" @click="openLotSheet">{{ game.name }}</button>
        <span class="count-txt">距 {{ nextIssue }} 截止</span>
        <span class="clock">{{ clockText }}</span>
      </div>
    </section>

    <section class="play-bar">
      <button class="play-left" type="button" @click="openRuleSheet">
        <span>{{ isPk10Quick ? quickSide : currentPlayLabel }}</span>
        <img class="play-info" :src="icons.info" alt="" />
      </button>
      <div class="play-right">
        <button
          v-if="!isPk10Quick"
          type="button"
          class="quick-play"
          :class="{ on: isCurrentPlayFav }"
          @click="toggleCurrentPlayFav"
        >
          快捷玩法
          <img :src="isCurrentPlayFav ? icons.heartOn : icons.heartOff" alt="" />
        </button>
        <button type="button" @click.stop="openPlaySheet">
          更多玩法
          <img :src="icons.menu" alt="" />
        </button>
      </div>
    </section>

    <div v-if="historyOpen" class="history-panel" :class="{ pk10: isPk10, 'lf-history-panel': !isPk10 }">
      <div class="history-head">
        <span class="history-h-issue">期次</span>
        <span class="history-h-nums">开奖号码</span>
      </div>
      <div
        ref="historyScrollRef"
        class="history-list"
        :class="{ 'lf-history-list': !isPk10 }"
        @wheel.stop
        @touchmove.stop
      >
        <div v-for="row in historyRows" :key="row.issue" class="history-item" :class="{ 'lf-history-item': !isPk10 }">
          <span class="history-issue">{{ row.issue }}</span>
          <div v-if="isPk10" class="balls sm pk10 history-balls">
            <span
              v-for="(n, i) in row.codes"
              :key="i"
              class="draw-ball color"
              :style="ballStyle(n)"
            >{{ formatBall(n) }}</span>
          </div>
          <div v-else class="history-nums">
            <span v-for="(n, i) in row.codes" :key="i">{{ n }}</span>
          </div>
        </div>
        <div class="history-list-spacer" aria-hidden="true" />
      </div>
      <button class="trend-side" type="button" @click="goTrend">走势图</button>
    </div>

    <div class="pick-area" :class="{ sum: isPk10Sum, quick: isPk10Quick, dim: historyOpen && !isPk10Quick }">
      <template v-if="isPk10Quick">
        <aside class="q-side">
          <button
            v-for="side in pk10Sides"
            :key="side"
            class="q-side-item"
            :class="{ on: quickSide === side }"
            type="button"
            @click="setQuickSide(side)"
          >{{ side }}</button>
        </aside>
        <div class="q-main" :class="{ 'sum-guess': isPk10SumGuess }">
          <div class="q-tabs">
            <button class="q-tab" type="button" @click="goRoadmap">
              <span>路子图</span>
              <img :src="iconRoadmap" alt="" />
            </button>
            <button class="q-tab" type="button" @click="goLongDragon">
              <span>两面长龙</span>
              <img :src="iconLongDragon" alt="" />
            </button>
          </div>
          <template v-if="isPk10TwoSide">
            <div class="side-grid">
              <template v-for="sec in pk10TwoSides" :key="sec.title">
                <div class="side-hd">{{ sec.title }}</div>
                <button
                  v-for="item in sec.items"
                  :key="item.key"
                  class="side-cell"
                  :class="{
                    on: twoSideBets.includes(item.key),
                    'chip-on': showChipStake && twoSideBets.includes(item.key),
                    dragon: item.tone === 'dragon',
                    tiger: item.tone === 'tiger'
                  }"
                  type="button"
                  @click="toggleTwoSideBet(item.key)"
                >
                  <span class="side-lab">
                    <small v-if="item.pair">{{ item.pair }}:</small>
                    {{ item.label }}
                  </span>
                  <em>{{ item.odds }}</em>
                  <span v-if="showChipStake && twoSideBets.includes(item.key)" class="chip-stake">
                    <img :src="icons.chip" alt="" />
                    <i>{{ betStakeOf(item.key) }}</i>
                  </span>
                </button>
              </template>
            </div>
          </template>
          <template v-else-if="isPk10DragonTiger">
            <div class="side-grid">
              <template v-for="sec in pk10DragonSections" :key="sec.title">
                <div class="side-hd">{{ sec.title }}</div>
                <button
                  v-for="item in sec.items"
                  :key="item.key"
                  class="side-cell dt-cell"
                  :class="{
                    on: twoSideBets.includes(item.key),
                    'chip-on': showChipStake && twoSideBets.includes(item.key),
                    dragon: item.tone === 'dragon',
                    tiger: item.tone === 'tiger'
                  }"
                  type="button"
                  @click="toggleTwoSideBet(item.key)"
                >
                  <span class="side-lab">{{ item.label }}</span>
                  <em>{{ item.odds }}</em>
                  <span v-if="showChipStake && twoSideBets.includes(item.key)" class="chip-stake">
                    <img :src="icons.chip" alt="" />
                    <i>{{ betStakeOf(item.key) }}</i>
                  </span>
                </button>
              </template>
            </div>
          </template>
          <template v-else-if="isPk10SumGuess">
            <div class="sum-tabs">
              <button
                v-for="tab in pk10SumTabs"
                :key="tab.key"
                class="sum-tab"
                :class="{ on: sumGuessTab === tab.key }"
                type="button"
                @click="sumGuessTab = tab.key"
              >{{ tab.label }}</button>
            </div>
            <div class="q-body-scroll">
              <div class="side-grid">
                <button
                  v-for="(item, i) in pk10SumOptions"
                  :key="item.num"
                  class="side-cell"
                  :class="{
                    on: sumGuessBets.includes(item.num),
                    'chip-on': showChipStake && sumGuessBets.includes(item.num),
                    wide: i === pk10SumOptions.length - 1 && pk10SumOptions.length % 2 === 1
                  }"
                  type="button"
                  @click="toggleSumGuess(item.num)"
                >
                  <span class="side-lab">{{ item.num }}</span>
                  <em>{{ item.odds }}</em>
                  <span v-if="showChipStake && sumGuessBets.includes(item.num)" class="chip-stake">
                    <img :src="icons.chip" alt="" />
                    <i>{{ betStakeOf(item.num) }}</i>
                  </span>
                </button>
              </div>
            </div>
          </template>
          <template v-else-if="isPk10RankSide">
            <div class="side-grid rank-grid">
              <template v-for="sec in pk10RankSections" :key="sec.title">
                <div class="side-hd">{{ sec.title }}</div>
                <button
                  v-for="num in pk10RankNums"
                  :key="`${sec.rank}-${num}`"
                  class="side-cell rank-cell"
                  :class="{ on: isRankBetOn(sec.rank, num), 'chip-on': showChipStake && isRankBetOn(sec.rank, num) }"
                  type="button"
                  @click="toggleRankBet(sec.rank, num)"
                >
                  <span class="rank-sq" :style="{ background: pk10BallColor(num) }">{{ num }}</span>
                  <em>{{ pk10RankOdds }}</em>
                  <span v-if="showChipStake && isRankBetOn(sec.rank, num)" class="chip-stake">
                    <img :src="icons.chip" alt="" />
                    <i>{{ betStakeOf(rankBetKey(sec.rank, num)) }}</i>
                  </span>
                </button>
              </template>
            </div>
          </template>
          <template v-else>
            <div v-if="showQuickRankPicker" class="q-ranks">
              <button
                v-for="item in quickRankOptions"
                :key="item.rank"
                class="q-rank"
                :class="{ on: quickRanks.includes(item.rank) }"
                type="button"
                @click="toggleQuickRank(item.rank)"
              >{{ item.title }}</button>
            </div>
            <p v-if="showQuickRankPicker" class="q-hint">请选择玩法与投注项目后再进行投注</p>
            <div class="q-grid">
              <button
                v-for="item in pk10QuickBets"
                :key="item.key"
                class="q-cell"
                :class="{
                  on: quickBets.includes(item.key),
                  'chip-on': showChipStake && quickBets.includes(item.key),
                  word: !item.num
                }"
                type="button"
                @click="toggleQuickBet(item.key)"
              >
                <span
                  v-if="item.num"
                  class="q-sq"
                  :style="{ background: pk10BallColor(item.num) }"
                >{{ item.label }}</span>
                <span v-else>{{ item.label }}</span>
                <em v-if="showChipStake && quickBets.includes(item.key)" class="q-odds">{{ pk10RankOdds }}</em>
                <span v-if="showChipStake && quickBets.includes(item.key)" class="chip-stake">
                  <img :src="icons.chip" alt="" />
                  <i>{{ betStakeOf(item.key) }}</i>
                </span>
              </button>
            </div>
          </template>
        </div>
      </template>

      <template v-else-if="isPk10Sum">
        <div class="quick-line sum-quick">
          <button
            v-for="q in sumQuicks"
            :key="q.key"
            type="button"
            @click="applySumQuick(q.key)"
          >
            {{ q.label }}
          </button>
        </div>
        <div class="pos-body">
          <span class="pos-name tall">{{ play.posName }}</span>
          <div class="num-grid cols-4">
            <button
              v-for="item in play.options"
              :key="item.num"
              class="num-cell"
              :class="{ on: selectedSumNums.includes(item.num) }"
              type="button"
              @click="toggleSum(item.num)"
            >
              <span class="odds-btn">
                <b>{{ item.num }}</b>
                <em>{{ item.odds }}</em>
              </span>
            </button>
          </div>
        </div>
      </template>

      <template v-else-if="play.layout === 'text'">
        <div class="ds-area">
          <div class="ds-box">
            <textarea v-model="textInput" class="ds-textarea" rows="8"></textarea>
            <div v-if="!textInput" class="ds-hint">
              <p v-for="(line, i) in textHintLines" :key="i" class="ds-line" :class="{ 'ds-line-head': i === 0 }">{{ line }}</p>
            </div>
          </div>
          <div class="ds-btns">
            <button class="ds-btn" type="button" @click="handleFileImport">
              <svg class="ds-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v12"/><path d="M8 7l4-4 4 4"/><path d="M4 14v4a2 2 0 002 2h12a2 2 0 002-2v-4"/></svg>
              <span>选择文件</span>
            </button>
            <button class="ds-btn" type="button" @click="textInput = ''">
              <svg class="ds-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21V10"/><path d="M5 10h14"/><path d="M7 10 9.2 4h5.6L17 10"/><path d="M6 14h12"/><path d="M7 17h10"/></svg>
              <span>清除选号</span>
            </button>
            <button class="ds-btn ds-btn-filter" type="button" @click="filterTextInput">
              <svg class="ds-ico ds-ico-red" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M8 12.5l2.5 2.5L16 9.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
              <span>过滤重复/无效号</span>
            </button>
          </div>
          <input ref="fileInputRef" type="file" accept=".txt" style="display:none" @change="onFileChange" />
        </div>
      </template>

      <template v-else-if="play.choiceStyle === 'dt'">
        <div class="dt-pick-area">
          <button
            v-for="d in play.choiceOptions"
            :key="d"
            class="dt-pick-cell"
            :class="{ on: selected[0]?.includes(d) }"
            type="button"
            @click="toggleNum(0, d)"
          >
            <span class="dt-pick-btn">{{ d }}</span>
          </button>
        </div>
      </template>

      <template v-else>
        <div v-if="play.showMiss" class="hot-gap" :class="{ open: gapPanelOpen, active: !!missMode && !gapPanelOpen }">
          <div v-if="gapPanelOpen" class="hot-gap-open">
            <button type="button" @click="closeGap">关闭</button>
            <button type="button" :class="{ on: missMode === 'miss' }" @click="pickGap('miss')">遗漏</button>
            <button type="button" :class="{ on: missMode === 'hot' }" @click="pickGap('hot')">冷热</button>
          </div>
          <button v-else class="hot-gap-closed" type="button" @click="gapPanelOpen = true">
            <template v-if="missMode === 'miss'">遗漏</template>
            <template v-else-if="missMode === 'hot'">冷热</template>
            <template v-else>冷热<br>遗漏</template>
          </button>
        </div>

        <section
          v-for="(pos, pi) in positions"
          :key="pos.name"
          class="pos-block"
          :class="{ 'quick-below': play.quickBelow, 'quick-over-grid': play.quickOverGrid }"
        >
          <div
            v-if="!play.quickBelow && !play.hideQuick && !play.quickOverGrid"
            class="quick-line"
            :class="{ first: pi === 0, panel: gapPanelOpen && pi === 0 }"
          >
            <button
              v-for="q in rowQuicksFor(pi)"
              :key="q.key"
              type="button"
              @click="applyQuick(pi, q.key)"
            >
              {{ q.label }}
            </button>
          </div>
          <div class="pos-body" :class="{ first: play.quickBelow && pi === 0 }">
            <span class="pos-name" :class="{ tall: (play.range || 10) > 10, dxds: !!play.choiceOptions }">{{ pos.name }}</span>
            <div v-if="play.quickOverGrid" class="pos-main">
              <div
                v-if="!play.hideQuick"
                class="quick-line over-grid"
              >
                <button
                  v-for="q in rowQuicksFor(pi)"
                  :key="q.key"
                  type="button"
                  @click="applyQuick(pi, q.key)"
                >
                  {{ q.label }}
                </button>
              </div>
              <div class="num-grid" :class="{ 'stat-corner': play.showMiss && !!missMode, 'cols-4': !!play.choiceOptions, 'dxds-grid': !!play.choiceOptions }">
                <button
                  v-for="d in (play.choiceOptions || Array.from({ length: play.range || 10 }, (_, i) => (play.rangeStart || 0) + i))"
                  :key="d"
                  class="num-cell"
                  :class="{ on: selected[pi]?.includes(d) }"
                  type="button"
                  @click="toggleNum(pi, d)"
                >
                  <template v-if="play.choiceOptions && play.choiceStyle !== 'dt'">
                    <span class="odds-btn">
                      <b>{{ d }}</b>
                      <em v-if="currentPlayKey !== 'front2-dxds' && currentPlayKey !== 'p3-back2-dxds' && currentPlayKey !== 'p5-back2-dxds'">{{ play.prize }}</em>
                    </span>
                  </template>
                  <template v-else>
                    <span class="num-btn" :class="{ color: play.colored }" :style="play.colored ? ballStyle(d) : null">{{ play.colored || (play.rangeStart || 0) === 1 ? formatBall(d) : d }}</span>
                  </template>
                  <span v-if="missMode" class="stat" :class="statClass(pi, d)">{{ statText(pi, d) }}</span>
                </button>
              </div>
            </div>
            <div v-else class="num-grid" :class="{ 'stat-corner': play.showMiss && !!missMode, 'cols-4': !!play.choiceOptions, 'dxds-grid': !!play.choiceOptions }">
              <button
                v-for="d in (play.choiceOptions || Array.from({ length: play.range || 10 }, (_, i) => (play.rangeStart || 0) + i))"
                :key="d"
                class="num-cell"
                :class="{ on: selected[pi]?.includes(d) }"
                type="button"
                @click="toggleNum(pi, d)"
              >
                <template v-if="play.choiceOptions && play.choiceStyle !== 'dt'">
                  <span class="odds-btn">
                    <b>{{ d }}</b>
                    <em v-if="currentPlayKey !== 'front2-dxds' && currentPlayKey !== 'p3-back2-dxds' && currentPlayKey !== 'p5-back2-dxds'">{{ play.prize }}</em>
                  </span>
                </template>
                <template v-else>
                  <span class="num-btn" :class="{ color: play.colored }" :style="play.colored ? ballStyle(d) : null">{{ play.colored || (play.rangeStart || 0) === 1 ? formatBall(d) : d }}</span>
                </template>
                <span v-if="missMode" class="stat" :class="statClass(pi, d)">{{ statText(pi, d) }}</span>
              </button>
            </div>
          </div>
          <div
            v-if="play.quickBelow"
            class="quick-line below"
            :class="{ first: pi === 0, panel: gapPanelOpen && pi === 0 }"
          >
            <button
              v-for="q in rowQuicksFor(pi)"
              :key="q.key"
              type="button"
              @click="applyQuick(pi, q.key)"
            >
              {{ q.label }}
            </button>
          </div>
        </section>
      </template>
    </div>

    <footer ref="footRef" class="bet-foot" :class="{ compact: isPk10Quick }" @click="closeDrawerIfOpen">
      <template v-if="isPk10Quick">
        <div class="sum-row compact-sum">
          <span>已选 <em>{{ betCount }}</em> 注 共 <em>{{ betAmount }}</em></span>
          <span class="balance">
            余额 <em>{{ hideBalance ? '***' : balance }}</em>
            <button type="button" aria-label="刷新" @click="refreshBalance">
              <img :src="icons.refresh" alt="" />
            </button>
            <button type="button" :aria-label="hideBalance ? '显示余额' : '隐藏余额'" @click="hideBalance = !hideBalance">
              <img :src="hideBalance ? icons.eyeOff : icons.eye" alt="" />
            </button>
          </span>
        </div>
        <div v-if="chipOpen" class="pk10-chip-bar">
          <button
            v-for="(n, i) in chipValues"
            :key="'chip-' + i"
            type="button"
            class="pk10-chip"
            :class="{
              active: chipEditOpen ? editChipIndex === i : Number(liveQuickAmount) === n,
              editing: chipEditOpen && editChipIndex === i
            }"
            @click="chipEditOpen ? selectEditChip(i) : pickChip(n)"
          >
            <img class="pk10-chip-bg" :src="chipIconAt(i)" :alt="String(displayChipValue(i))" />
            <span class="pk10-chip-txt" :class="{ long: String(displayChipValue(i)).length > 3 }">{{ displayChipValue(i) }}</span>
          </button>
          <button class="pk10-chip-edit" type="button" aria-label="编辑筹码" @click="toggleChipEdit">✎</button>
        </div>
        <div v-if="keypadOpen || chipEditOpen" class="keypad">
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('1') : pressKey('1')">1</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('2') : pressKey('2')">2</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('3') : pressKey('3')">3</button>
          <button class="side" type="button" @click="chipEditOpen ? closeChipEdit() : hideKeypad()">
            <img class="vk-ico" :src="icons.vkHide" alt="" />
            隐藏
          </button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('4') : pressKey('4')">4</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('5') : pressKey('5')">5</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('6') : pressKey('6')">6</button>
          <button class="side" type="button" @click="chipEditOpen ? pressChipKey('clear') : pressKey('clear')">
            <img class="vk-ico" :src="icons.vkClear" alt="" />
            清零
          </button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('7') : pressKey('7')">7</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('8') : pressKey('8')">8</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('9') : pressKey('9')">9</button>
          <button class="side ok" type="button" @click="chipEditOpen ? confirmChipEdit() : confirmKeypad()">
            <img class="vk-ico ok" :src="icons.vkOk" alt="" />
            确认
          </button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('.') : pressKey('.')">.</button>
          <button class="key" type="button" @click="chipEditOpen ? pressChipKey('0') : pressKey('0')">0</button>
          <button class="key vk-back" type="button" aria-label="退格" @click="chipEditOpen ? pressChipKey('del') : pressKey('del')">
            <img class="vk-ico" :src="icons.vkBack" alt="" />
            <span>回退</span>
          </button>
        </div>
        <div class="quick-act compact-foot">
          <button
            class="trash-btn square"
            :class="{ active: betCount > 0 }"
            type="button"
            aria-label="清空"
            :disabled="!betCount"
            @click="clearQuick"
          >
            <img :src="icons.trashCart" alt="" />
          </button>
          <div class="amt-wrap" :class="{ 'chip-only': chipOpen }">
            <button
              v-show="!chipOpen"
              class="amt-box"
              :class="{ on: keypadOpen, fill: !!liveQuickAmount && !keypadOpen }"
              type="button"
              @click="openKeypad"
            >
              {{ keypadOpen ? (draft || '') : (liveQuickAmount || '请输入金额') }}
            </button>
            <button class="chip-btn" :class="{ on: chipOpen }" type="button" aria-label="筹码" @click.stop="toggleChipSheet">
              <img :src="chipOpen ? icons.chipOrange : icons.chipRound" alt="" />
            </button>
          </div>
          <button class="act primary" :class="{ ready: canQuickBet }" type="button" :disabled="!canQuickBet" @click="openBetConfirm">立即投注</button>
        </div>
      </template>

      <template v-else>
      <div class="prize-row">
        <span class="prize">玩法奖金 <em>{{ prizeText }}</em> U</span>
        <div class="stepper">
          <button type="button" @click="changeMultiple(-1)">−</button>
          <button
            class="mult-box"
            :class="{ on: keypadOpen }"
            type="button"
            @click="openKeypad"
          >
            <span v-if="keypadOpen">{{ draft || '' }}</span>
            <span v-else-if="multiple > 1">{{ multiple }}倍</span>
            <span v-else class="ph">倍数</span>
          </button>
          <button type="button" @click="changeMultiple(1)">+</button>
          <button class="unit-btn" type="button">U</button>
        </div>
      </div>

      <div v-if="keypadOpen" class="keypad">
        <button class="key" type="button" @click="pressKey('1')">1</button>
        <button class="key" type="button" @click="pressKey('2')">2</button>
        <button class="key" type="button" @click="pressKey('3')">3</button>
        <button class="side" type="button" @click="hideKeypad">
          <img class="vk-ico" :src="icons.vkHide" alt="" />
          隐藏
        </button>
        <button class="key" type="button" @click="pressKey('4')">4</button>
        <button class="key" type="button" @click="pressKey('5')">5</button>
        <button class="key" type="button" @click="pressKey('6')">6</button>
        <button class="side" type="button" @click="pressKey('clear')">
          <img class="vk-ico" :src="icons.vkClear" alt="" />
          清零
        </button>
        <button class="key" type="button" @click="pressKey('7')">7</button>
        <button class="key" type="button" @click="pressKey('8')">8</button>
        <button class="key" type="button" @click="pressKey('9')">9</button>
        <button class="side ok" type="button" @click="confirmKeypad">
          <img class="vk-ico ok" :src="icons.vkOk" alt="" />
          确认
        </button>
        <button class="key" type="button" @click="pressKey('.')">.</button>
        <button class="key" type="button" @click="pressKey('0')">0</button>
        <button class="key vk-back" type="button" aria-label="退格" @click="pressKey('del')">
          <img class="vk-ico" :src="icons.vkBack" alt="" />
          <span>回退</span>
        </button>
      </div>

      <div class="order-info">
        <div v-if="play.showLimit" class="limit-row">{{ play.limitText || '该玩法订单投注上限：800 注' }}</div>
        <div class="sum-row">
          <span>已选 <em class="stack">{{ betCount }}</em> 注，共<em class="amount">{{ betAmount }}</em></span>
          <span class="balance">
            余额<em class="balance-num">{{ hideBalance ? '***' : balance }}</em>
            <button type="button" aria-label="刷新" @click="refreshBalance">
              <img :src="icons.refresh" alt="" />
            </button>
            <button type="button" :aria-label="hideBalance ? '显示余额' : '隐藏余额'" @click="hideBalance = !hideBalance">
              <img :src="hideBalance ? icons.eyeOff : icons.eye" alt="" />
            </button>
          </span>
        </div>
      </div>
      <div class="act-row">
        <button class="cart-btn" :class="{ active: cartCount > 0 }" type="button" aria-label="购彩篮" @click="openCart">
          <span class="cart-icon-wrap">
            <img :src="cartCount ? icons.cartActive : icons.cart" alt="" />
            <i v-if="cartCount" class="cart-num" :class="{ long: cartCount > 9 }">{{ cartCount > 99 ? '99+' : cartCount }}</i>
          </span>
        </button>
        <button class="act hand" type="button" :disabled="!canOfficialBet" @click="allIn">梭哈</button>
        <button class="act add" type="button" :disabled="!canOfficialBet" @click="addCart">添加选号</button>
        <button class="act primary" type="button" :disabled="!canOfficialBet" @click="openBetConfirm">立即投注</button>
      </div>
      </template>
    </footer>

    <div v-if="lotSheet" class="lot-mask" @click="lotSheet = false">
      <div class="lot-panel" @click.stop>
        <div class="lot-scroll">
          <section class="lot-acc">
            <button class="lot-head" type="button" @click="toggleAcc('fav')">
              <img class="lot-dice" :src="lotBoxIcon" alt="" />
              收藏彩种选择
              <span class="lot-chev" :class="{ open: openAcc === 'fav' }" aria-hidden="true">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5" fill="none" stroke="#c0c0c0" stroke-width="1.4"/><path d="M8.2 10.4 12 14.2l3.8-3.8" fill="none" stroke="#b0b0b0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
            </button>
            <div v-show="openAcc === 'fav'" class="lot-body">
              <button
                v-for="item in favPickerGames"
                :key="'fav' + item.id"
                class="lot-game"
                :class="{ on: game.id === item.id }"
                type="button"
                @click="pickLottery(item.id)"
              >
                {{ item.name }}
              </button>
            </div>
          </section>

          <section v-for="cat in visibleCats" :key="cat.key" class="lot-acc">
            <button class="lot-head" type="button" @click="toggleAcc(cat.key)">
              <img class="lot-dice" :src="lotBoxIcon" alt="" />
              {{ cat.label }}
              <span class="lot-chev" :class="{ open: openAcc === cat.key }" aria-hidden="true">
                <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5" fill="none" stroke="#c0c0c0" stroke-width="1.4"/><path d="M8.2 10.4 12 14.2l3.8-3.8" fill="none" stroke="#b0b0b0" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </span>
            </button>
            <div v-show="openAcc === cat.key" class="lot-body">
              <button
                v-for="item in gamesForLotCat(cat)"
                :key="item.id"
                class="lot-game"
                :class="{ on: game.id === item.id }"
                type="button"
                @click="pickLottery(item.id)"
              >
                {{ item.name }}
              </button>
            </div>
          </section>
        </div>
        <button class="lot-cancel" type="button" @click="lotSheet = false">取消</button>
      </div>
    </div>

    <div v-if="ruleSheet" class="rule-mask sheet" @click="ruleSheet = false">
      <div class="rule-panel trad" @click.stop>
        <div class="rule-head">游戏说明</div>
        <div class="rule-tabs">
          <button type="button" :class="{ on: ruleTab === 'rules' }" @click="setRuleTab('rules')">玩法规则</button>
          <button type="button" :class="{ on: ruleTab === 'prize' }" @click="setRuleTab('prize')">奖金总览</button>
          <button type="button" :class="{ on: ruleTab === 'game' }" @click="setRuleTab('game')">彩种说明</button>
        </div>
        <div ref="ruleBodyRef" class="rule-body" :class="{ 'play-rule': ruleTab === 'rules' && !playHelp }">
          <template v-if="ruleTab === 'rules'">
            <div v-if="playHelp" class="rule-play">
              <div class="rule-play-name">{{ playHelp.title }}</div>
              <p>{{ playHelp.desc }}</p>
              <p>{{ playHelp.example }}</p>
            </div>
            <template v-else>
            <ul class="rule-list">
            <li>
              <div>单期最高奖金(含本金)<span class="red">500000 U</span></div>
              <div>单笔最高奖金(含本金)<span class="red">400000 U</span></div>
              <div>彩种单期投注最大金额<span class="red">200000U</span></div>
              <div class="deduce">中奖金额超出单笔（单期）奖金上限，超出部份系统将自动扣除。</div>
            </li>
            <li>
              <div>开奖时间：<span class="red">00:00:00~04:58:30</span></div>
              <div>开奖频率：<span class="red">每天200期，1分30秒一期</span></div>
            </li>
            <li>
              <div>开奖时间：<span class="red">06:00:00~23:58:30</span></div>
              <div>开奖频率：<span class="red">每天720期，1分30秒一期</span></div>
            </li>
            <li class="special">
              <p>官方星座网：<a href="https://lotteryxz.com" target="_blank" rel="noopener">https://lotteryxz.com</a></p>
              <p>参考网址：<a href="https://278250.com/#/PK10/TCSPK10/" target="_blank" rel="noopener">https://278250.com/#/PK10/TCSPK10/</a></p>
            </li>
            <li>以下所有投注皆含本金。</li>
            <li><span class="bold">冠亚和值大小单双：</span></li>
            <li class="sub">
              <span class="bold">冠亚和值单、双：</span>"冠亚和值"为单视为投注"单"的注单视为中奖，为双视为投注"双"的注单视为中奖。
            </li>
            <li class="sub">
              <span class="bold">冠亚和值大、小：</span>"冠亚和值" 3至11为小，12至19为大的注单视为中奖。
            </li>
            <li class="sub"><span class="bold">第一名～第十名 两面：</span>指单、双、大、小。</li>
            <li class="sub">
              <span class="bold">单、双：</span>号码为双的叫双，如4、8；号码为单的叫单，如5、9。
            </li>
            <li class="sub">
              <span class="bold">大、小：</span>开出之号码大于或等于6为大，小于或等于5为小。
            </li>
            <li class="sub">
              <span class="bold">冠亚和值：</span>"冠亚和值"可能出现的结果为3~19，投中对应"冠亚和值"数字的视为中奖，其余视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">冠亚季和值：</span>"冠亚季和值"可能出现的结果为6~27，投中对应"冠亚季和值"数字的视为中奖，其余视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">首尾和值：</span>"首尾和值"可能出现的结果为3~19，投中对应"首尾和值"数字的视为中奖，其余视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">第1-10名：</span>从指定位置开始选择最少一个,最多十个位置，任意1个位置或者多个位置上选择1个号码，所选号码与相同位置上的开奖号码一致视为中奖，其余视为不中奖。
            </li>
            <li><span class="bold">1~5龙虎【注意规则】为：</span></li>
            <li class="sub">
              <span class="bold">冠军龙虎：</span>"第一名"车号大于"第十名"车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">亚军龙虎：</span>"第二名"车号大于"第九名"车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">第三名龙虎：</span>"第三名"车号大于"第八名"车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">第四名龙虎：</span>"第四名"车号大于"第七名"车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。
            </li>
            <li class="sub">
              <span class="bold">第五名龙虎：</span>"第五名"车号大于"第六名"车号视为【龙】中奖、反之小于视为【虎】中奖，其余情形视为不中奖。
            </li>
            <li class="bold">番摊玩法</li>
          </ul>
          <div class="fan-tan-table">
            <div class="fan-tan-row head">
              <div class="fan-lab">和值/4=番数</div>
              <div class="fan-nums">和值为以下数字</div>
            </div>
            <div class="fan-tan-row c1">
              <div class="fan-lab">1番(余1)</div>
              <div class="fan-nums"><span>9</span><span>13</span><span>17</span><span>21</span><span>25</span></div>
            </div>
            <div class="fan-tan-row c2">
              <div class="fan-lab">2番(余2)</div>
              <div class="fan-nums"><span>6</span><span>10</span><span>14</span><span>18</span><span>22</span><span>26</span></div>
            </div>
            <div class="fan-tan-row c3">
              <div class="fan-lab">3番(余3)</div>
              <div class="fan-nums"><span>7</span><span>11</span><span>15</span><span>19</span><span>23</span><span>27</span></div>
            </div>
            <div class="fan-tan-row c4">
              <div class="fan-lab">4番(可整除)</div>
              <div class="fan-nums"><span>8</span><span>12</span><span>16</span><span>20</span><span>24</span></div>
            </div>
          </div>
          <ul class="rule-list">
            <li class="sub">
              <span class="bold">番: </span>开奖后前3名数字相加总数，除以4，余下的数据为开奖号码，可整除为4番；如投注1：开奖第一名为3、第二名为4、第三名为2；总和为3+4+2＝9；开奖为9/4＝2 余1(则开奖为1番)。
            </li>
            <li class="sub">
              <span class="bold">念: </span>开奖后前3名数字相加总数，除以4，余下的数据为开奖号码；如整除为4番；前个号码与奖号匹配则中奖，后一个号码匹配则退本金，都不匹配则算输。如投注1念4，番开1则中奖，番开4则退本金，其余算输。
            </li>
            <li class="sub">
              <span class="bold">角: </span>开奖后前3名数字相加总数，除以4，余下的数据为开奖号码；如整除为4番；投注两个结果，其中一个结果跟开奖孤番相同则中奖。如投注1-4角：开奖后为1番或是4番，则中奖。
            </li>
            <li class="sub">
              <span class="bold">大小单双: </span>开奖后前3名数字相加总数，除以4，余下的数据为开奖号码；如整除为4番。1、2番为小，3、4番为大；1、3番为单，2、4番为双。如投注小，孤番开1或2则中奖，其余算输。
            </li>
          </ul>
            </template>
          </template>

          <template v-else-if="ruleTab === 'prize'">
            <div class="prize-table">
              <div class="prize-tr head">
                <span>奖金类型</span>
                <span>奖金数额(U)</span>
              </div>
              <div class="prize-tr">
                <span>单期最高奖金(含本金)</span>
                <span class="red">500000</span>
              </div>
              <div class="prize-tr">
                <span>单笔最高奖金(含本金)</span>
                <span class="red">400000</span>
              </div>
              <div class="prize-tr">
                <span>彩种单期投注最大金额</span>
                <span class="red">200000</span>
              </div>
              <template v-if="prizeHelpRows">
                <div v-for="row in prizeHelpRows" :key="row.label" class="prize-tr">
                  <span>{{ row.label }}</span>
                  <span class="red">{{ row.value }}</span>
                </div>
              </template>
              <div v-else class="prize-tr">
                <span>玩法奖金:</span>
                <span class="red">{{ prizeHelpValue }}</span>
              </div>
            </div>
            <div class="prize-note">
              <p class="prize-warn">中奖金额超出单笔（单期）奖金上限，超出部份系统将自动扣除。</p>
              <template v-if="!prizeHelpRows">
                <p>【单挑模式】说明：投注的中奖概率低于或等于1%的均为单挑模式。</p>
                <p>（单挑每期订单奖金上限50000.00 U，超出的奖金系统将予以扣除）</p>
                <p>单挑奖金为每一期单挑中奖无论购买几种玩法，投注几注，只要属于单挑模式的投注，无论同期购买几单单挑玩法，同期单挑奖金最高金额为50000U。</p>
              </template>
            </div>
          </template>

          <template v-else>
            <div class="rule-game">
              <template v-for="(row, i) in lotteryHelp.schedules" :key="i">
                <p>开奖时间：<span class="red">{{ row.time }}</span></p>
                <p>开奖频率：<span class="red">{{ row.freq }}</span></p>
              </template>
              <p v-if="lotteryHelp.official">
                官方星座网：<a :href="lotteryHelp.official" target="_blank" rel="noopener">{{ lotteryHelp.official }}</a>
              </p>
              <p>
                参考网址：<a :href="lotteryHelp.url" target="_blank" rel="noopener">{{ lotteryHelp.url }}</a>
              </p>
            </div>
          </template>
        </div>
        <button class="rule-close" type="button" @click="ruleSheet = false">关闭</button>
      </div>
    </div>

    <div v-if="quickPlayTip" class="quick-play-tip">尚无加入快捷玩法</div>
    <div v-if="pickTip" class="quick-play-tip">{{ pickTip }}</div>
    </div>

    <aside v-if="playSheet" class="play-drawer" @click.stop>
          <div class="play-tools">
            <button type="button" :class="{ off: !soundOn }" @click="toggleSound">
              <img class="tool-icon" :src="soundOn ? icons.playSoundOn : icons.playSoundOff" alt="" />
              提示音
            </button>
            <button type="button" :class="{ off: !noticeOn }" @click="toggleNotice">
              <img class="tool-icon" :src="noticeOn ? icons.playNoticeOn : icons.playNoticeOff" alt="" />
              盈亏通知
            </button>
          </div>
          <div class="play-cats">
            <button
              v-for="tab in playModeTabs"
              :key="tab.key"
              type="button"
              :class="{ on: sheetPlayMode === tab.key }"
              @click="switchSheetMode(tab.key)"
            >{{ tab.name }}</button>
          </div>
          <div class="play-list">
            <section v-for="group in sheetMenu" :key="group.key" class="play-group">
              <button class="play-row" type="button" @click="onPlayGroupClick(group)">
                <span class="play-heart" aria-hidden="true">
                  <img :src="groupHasFav(group) ? icons.heartOn : icons.heartOff" alt="" />
                </span>
                <span class="play-name">
                  {{ group.name }}
                  <i v-if="groupHasActive(group)" class="play-check">✓</i>
                  <em v-if="group.quick">{{ favPlayCount }}</em>
                </span>
                <i v-if="!isEntJumpGroup(group)" class="play-caret" :class="{ open: openPlayGroup === group.key }" />
              </button>
              <div v-show="!isEntJumpGroup(group) && openPlayGroup === group.key && playGroupChildren(group).length" class="play-subs">
                <button
                  v-for="item in playGroupChildren(group)"
                  :key="item.key"
                  class="play-sub"
                  :class="{ on: currentPlayKey === item.key }"
                  type="button"
                  @click="pickPlay(item, group)"
                >
                  <span class="play-heart sm" @click.stop="toggleFavPlay(item.key)">
                    <img :src="favPlays.includes(item.key) ? icons.heartOn : icons.heartOff" alt="" />
                  </span>
                  {{ item.name }}
                </button>
              </div>
            </section>
          </div>
    </aside>

    <div v-if="betConfirmSheet" class="bet-confirm-mask" :class="{ cards: isArcherRacing }" @click="closeBetConfirm">
      <div class="bet-confirm-panel" :class="{ cards: isArcherRacing }" @click.stop>
        <h3 class="bet-confirm-title">投注信息确认</h3>
        <template v-if="isArcherRacing">
          <div class="bet-confirm-list">
            <div v-for="item in confirmItems" :key="item.id" class="bet-confirm-card">
              <div class="bet-confirm-card-body">
                <p>玩法：{{ item.play }}</p>
                <p>号码：<em>{{ item.code }}</em></p>
                <p>奖金：{{ fmtOdds(item.odds) }}</p>
                <p>单注金额：</p>
                <input
                  class="bet-confirm-amt"
                  inputmode="numeric"
                  :value="item.amount"
                  @input="onConfirmAmount(item, $event)"
                />
                <p>预计可赢：{{ expectedWin(item) }}</p>
              </div>
              <button class="bet-confirm-del" type="button" aria-label="删除" @click="removeConfirmItem(item.id)">
                <img :src="icons.confirmTrash" alt="" />
              </button>
            </div>
          </div>
          <div class="bet-confirm-total cards">总计： {{ confirmCount }}注 / {{ confirmAmount }} U</div>
        </template>
        <template v-else>
          <div class="bet-confirm-info">
            <p>彩种：{{ game.name }}</p>
            <p>期号：第{{ nextIssue }}期</p>
            <p>是否追号：否</p>
          </div>
          <div class="bet-confirm-total">
            总计： <em>{{ betCount }}注 / {{ betAmount }} U</em>
          </div>
        </template>
        <p class="bet-confirm-note">订单确认后不可取消。</p>
        <label v-if="!isArcherRacing" class="bet-confirm-skip">
          <input v-model="confirmSkipToday" type="checkbox" />
          <span class="dot" aria-hidden="true"></span>
          <span>今日不再显示</span>
        </label>
        <div class="bet-confirm-actions">
          <button type="button" @click="closeBetConfirm">取消</button>
          <button type="button" class="ok" :disabled="isArcherRacing && !confirmAmount" @click="confirmBet">确认</button>
        </div>
      </div>
    </div>
    <BetFeedbackModals
      :balance-tip-sheet="balanceTipSheet"
      :balance-tip-countdown="balanceTipCountdown"
      :close-balance-tip="closeBalanceTip"
      :bet-success-sheet="betSuccessSheet"
      :bet-success-countdown="betSuccessCountdown"
      :close-bet-success-tip="closeBetSuccessTip"
    />
  </div>
</template>

<script>
export default { name: 'BetPage' }
</script>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppHeader from '@/components/AppHeader.vue'
import BetFeedbackModals from '@/components/BetFeedbackModals.vue'
import { games, favPickerList, gamesByGroup as listGamesByGroup, visibleLotCats, syncGameVisibility, LOT_SHEET_CATS, gamesForLotCat } from '@/data/games'
import { generateDraws, getDigitLen } from '@/data/trend'
import { generatePk10Draws, getPlayConfig, getPlayMenu, getPlayModes, defaultPlayMode, defaultPlayKey, PLAY_MODE_TABS, getPlayHelp, getSumPlayType, LOTTERY_HELP, periodSeconds, pk10BallColor, pk10AttrSummary, PK10_RANKS, PK10_SIDES, PK10_QUICK_BETS, PK10_TWO_SIDE_SECTIONS, PK10_SUM_TABS, PK10_SUM_MAP, PK10_RANK_SIDE_MAP, PK10_RANK_NUMS, PK10_RANK_ODDS, PK10_DT_SECTIONS } from '@/data/bet'
import { lgwApi } from '@/api/lgw'
import { usePeriodPickPersist } from '@/composables/usePeriodPickPersist'
import lotBoxIcon from '@/assets/lobby/ui/lot-box.svg'
import iconInfo from '@/assets/lobby/ui/bet-info.svg'
import iconHeart from '@/assets/lobby/ui/bet-heart.svg'
import iconPlayHeartOn from '@/assets/lobby/ui/play-heart-on.svg'
import iconPlayHeartOff from '@/assets/lobby/ui/play-heart-off.svg'
import iconPlaySoundOn from '@/assets/lobby/ui/play-sound-on.svg'
import iconPlaySoundOff from '@/assets/lobby/ui/play-sound-off.svg'
import iconPlayNoticeOn from '@/assets/lobby/ui/play-notice-on.svg'
import iconPlayNoticeOff from '@/assets/lobby/ui/play-notice-off.svg'
import iconMenu from '@/assets/lobby/ui/bet-menu.svg'
import iconCart from '@/assets/lobby/ui/bet-cart.svg'
import iconCartActive from '@/assets/lobby/ui/bet-cart-active.svg'
import iconEye from '@/assets/lobby/ui/bet-eye.svg'
import iconEyeOff from '@/assets/lobby/ui/bet-eye-off.svg'
import iconRefresh from '@/assets/lobby/ui/bet-refresh.svg'
import historyDownIcon from '@/assets/lobby/ui/history-caret.svg'
import iconTrash from '@/assets/lobby/ui/bet-trash.svg'
import iconTrashCart from '@/assets/lobby/ui/cart-garbage.svg'
import iconScan from '@/assets/lobby/ui/bet-scan.svg'
import iconChip from '@/assets/lobby/ui/bet-chip-orig.png'
import iconChipOrange from '@/assets/lobby/ui/chip-orange.svg'
import iconChipRound from '@/assets/lobby/ui/bet-chip-round.svg'
import chipFace10 from '@/assets/lobby/ui/chip-10.svg'
import chipFace50 from '@/assets/lobby/ui/chip-50.svg'
import chipFace100 from '@/assets/lobby/ui/chip-100.svg'
import chipFace200 from '@/assets/lobby/ui/chip-200.svg'
import chipFace500 from '@/assets/lobby/ui/chip-500.svg'
import iconRoadmap from '@/assets/lobby/ui/bet-roadmap.svg'
import iconLongDragon from '@/assets/lobby/ui/bet-longdragon.svg'
import iconVkHide from '@/assets/lobby/ui/vk-hide.svg'
import iconVkClear from '@/assets/lobby/ui/vk-clear.svg'
import iconVkBack from '@/assets/lobby/ui/vk-back.svg'
import iconVkOk from '@/assets/lobby/ui/vk-ok.svg'
import iconConfirmTrash from '@/assets/lobby/ui/confirm-trash.svg'
import { useTheme } from '@/composables/useTheme'
import { useBetFootSpace } from '@/composables/useBetFootSpace'
import { useActiveGame } from '@/composables/useActiveGame'
import { useBetFeedback } from '@/composables/useBetFeedback'
import { getBetPath } from '@/composables/betRoute'
import '@/styles/lf-bet-shell.css'

const { night } = useTheme()
const footRef = ref(null)
useBetFootSpace(footRef)

const icons = {
  info: iconInfo,
  heart: iconHeart,
  heartOn: iconPlayHeartOn,
  heartOff: iconPlayHeartOff,
  playSoundOn: iconPlaySoundOn,
  playSoundOff: iconPlaySoundOff,
  playNoticeOn: iconPlayNoticeOn,
  playNoticeOff: iconPlayNoticeOff,
  menu: iconMenu,
  cart: iconCart,
  cartActive: iconCartActive,
  eye: iconEye,
  eyeOff: iconEyeOff,
  refresh: iconRefresh,
  trash: iconTrash,
  trashCart: iconTrashCart,
  scan: iconScan,
  chip: iconChip,
  chipOrange: iconChipOrange,
  chipRound: iconChipRound,
  vkHide: iconVkHide,
  vkClear: iconVkClear,
  vkBack: iconVkBack,
  vkOk: iconVkOk,
  confirmTrash: iconConfirmTrash
}

const route = useRoute()
const router = useRouter()
const { currentGame: game, setActiveGame, ensureGameQuery } = useActiveGame()
ensureGameQuery(route, router)
const lotSheet = ref(false)
const ruleSheet = ref(false)
const ruleTab = ref('rules')
const ruleBodyRef = ref(null)
const openAcc = ref('fav')

const setRuleTab = async (tab) => {
  ruleTab.value = tab
  await nextTick()
  if (ruleBodyRef.value) ruleBodyRef.value.scrollTop = 0
}

const openRuleSheet = async () => {
  ruleTab.value = 'rules'
  ruleSheet.value = true
  await nextTick()
  if (ruleBodyRef.value) ruleBodyRef.value.scrollTop = 0
}
const lotCats = LOT_SHEET_CATS
const rowQuicks = [
  { key: 'all', label: '全' },
  { key: 'big', label: '大' },
  { key: 'small', label: '小' },
  { key: 'odd', label: '奇' },
  { key: 'even', label: '偶' },
  { key: 'clear', label: '清' }
]
const globalQuicks = rowQuicks.filter((q) => q.key !== 'all')
const sumQuicks = rowQuicks.filter((q) => q.key !== 'clear')
const quickMap = {
  all: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  big: [5, 6, 7, 8, 9],
  small: [0, 1, 2, 3, 4],
  odd: [1, 3, 5, 7, 9],
  even: [0, 2, 4, 6, 8],
  clear: []
}

const playSheet = ref(false)
let drawerJustOpened = false
const betConfirmSheet = ref(false)
const confirmItems = ref([])
const confirmSkipToday = ref(false)
const {
  balanceTipSheet,
  balanceTipCountdown,
  closeBalanceTip,
  betSuccessSheet,
  betSuccessCountdown,
  closeBetSuccessTip,
  openBalanceTip,
  executeBet
} = useBetFeedback()
const playMode = ref(defaultPlayMode(game.value))
const sheetPlayMode = ref(playMode.value)
const currentPlayKey = ref(defaultPlayKey(game.value, playMode.value))
const openPlayGroup = ref('front3')
const soundOn = ref(true)
const noticeOn = ref(true)
const BET_FAV_STORAGE_PREFIX = 'bet-fav-plays-'
const loadFavPlaysFor = (gameId) => {
  try {
    const raw = JSON.parse(localStorage.getItem(`${BET_FAV_STORAGE_PREFIX}${gameId || 0}`) || '[]')
    if (Array.isArray(raw)) return raw.filter((k) => typeof k === 'string' && k)
  } catch (_) { /* ignore */ }
  return []
}
const saveFavPlays = () => {
  try {
    localStorage.setItem(`${BET_FAV_STORAGE_PREFIX}${game.value?.id || 0}`, JSON.stringify(favPlays.value))
  } catch (_) { /* ignore */ }
}
const favPlays = ref(loadFavPlaysFor(game.value?.id))
watch(() => game.value?.id, (id) => {
  favPlays.value = loadFavPlaysFor(id)
})
const playModeTabs = computed(() => PLAY_MODE_TABS.filter((tab) => getPlayModes(game.value).includes(tab.key)))
const playMenu = computed(() => getPlayMenu(game.value, playMode.value))
const sheetMenu = computed(() => getPlayMenu(game.value, sheetPlayMode.value))
const play = computed(() => getPlayConfig(game.value, currentPlayKey.value))
const lotteryHelp = computed(() => {
  const preset = LOTTERY_HELP[Number(game.value?.id)] || LOTTERY_HELP[game.value?.group]
  if (preset) return preset
  const sec = periodSeconds(game.value)
  const perDay = Math.max(1, Math.floor(86400 / sec))
  const freq = sec % 60 === 0 ? `${sec / 60}分一期` : `${sec}秒一期`
  return {
    schedules: [{ time: '00:00:00~23:59:00', freq: `每天${perDay}期，${freq}` }],
    official: '',
    url: 'https://278250.com/#/PK10/TCG1FPK10/'
  }
})
const currentPlayLabel = computed(() => {
  const groups = playMenu.value || []
  let name = ''
  for (const g of groups) {
    const found = (g.children || []).find((item) => item.key === currentPlayKey.value)
    if (found?.name) {
      name = found.name
      break
    }
  }
  if (!name) name = play.value.playName || ''
  // 仅文本单式盘补（单式）；数字盘菜单名已区分，不追加
  if (
    play.value.layout === 'text'
    && /直选/.test(name)
    && name !== 'P3直选'
    && !/组选|和值|大小单双|（单式）|\(单式\)/.test(name)
  ) {
    name = `${name}（单式）`
  }
  return name
})
const textHintLines = computed(() => {
  const raw = play.value.placeholder || '每注之间可以用回车、空格、逗号[,]或者分号[;]隔开\n123 456\n123,456'
  return String(raw).split('\n').filter(Boolean)
})
const positions = computed(() => play.value.positions || [
  { name: '百位', index: 0 },
  { name: '十位', index: 1 },
  { name: '个位', index: 2 }
])
/** 猜前四 / 猜前五：每位至少选 1 个即可投注，可选多个 */
const isPk10FrontCombo = computed(() =>
  currentPlayKey.value === 'pk10-front4' || currentPlayKey.value === 'pk10-front5'
)
const isPositionPlay = computed(() => play.value.mode === 'position')
const isPk10 = computed(() => game.value?.group === 'PK10')
const isP3p5 = computed(() => Number(game.value?.id) === 15)
const isArcherRacing = computed(() => Number(game.value?.id) === 1802)
const isPk10Ent = computed(() => isPk10.value && playMode.value === 'entertainment')
const pk10View = ref(isPk10Ent.value ? 'quick' : 'sum')
const pk10ResultAttr = ref(false)
const isPk10Sum = computed(() => (isPk10Ent.value && pk10View.value === 'sum') || play.value.layout === 'sum')
const isPk10Quick = computed(() => isPk10Ent.value && pk10View.value !== 'sum')
const pk10Ranks = PK10_RANKS
const pk10Sides = PK10_SIDES
const pk10QuickBets = PK10_QUICK_BETS
const pk10TwoSides = PK10_TWO_SIDE_SECTIONS
const pk10DragonSections = PK10_DT_SECTIONS
const pk10SumTabs = PK10_SUM_TABS
const pk10RankNums = PK10_RANK_NUMS
const pk10RankOdds = PK10_RANK_ODDS
const quickSide = ref('快捷')
const isPk10TwoSide = computed(() => isPk10Quick.value && quickSide.value === '两面')
const isPk10DragonTiger = computed(() => isPk10Quick.value && quickSide.value === '龙虎斗')
const isPk10SumGuess = computed(() => isPk10Quick.value && quickSide.value === '猜和值')
const isPk10RankSide = computed(() => isPk10Quick.value && !!PK10_RANK_SIDE_MAP[quickSide.value])
const pk10RankSections = computed(() => {
  const ranks = PK10_RANK_SIDE_MAP[quickSide.value] || []
  return ranks.map((rank) => ({
    rank,
    title: PK10_RANKS[rank]
  }))
})
const showQuickRankPicker = computed(() => isPk10Quick.value && quickSide.value === '快捷')
const quickRankOptions = computed(() => pk10Ranks.map((title, rank) => ({ rank, title })))
const quickRanks = ref([])
const quickBets = ref([])
const twoSideBets = ref([])
const rankBets = ref([])
const sumGuessTab = ref('gy')
const sumGuessBets = ref([])
const pk10SumOptions = computed(() => PK10_SUM_MAP[sumGuessTab.value] || [])
const quickAmount = ref('')
const chipOpen = ref(false)
/** 筹码模式下各投注项累计金额；正常模式选中时同步为当前单价 */
const chipStakes = ref({})
const PK10_CHIP_STORAGE_KEY = 'pk10-chip-values'
const DEFAULT_CHIP_VALUES = [10, 50, 100, 300, 500]
const CHIP_ICON_LIST = [chipFace10, chipFace50, chipFace100, chipFace200, chipFace500]
const loadChipValues = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(PK10_CHIP_STORAGE_KEY) || 'null')
    if (Array.isArray(raw) && raw.length === 5) {
      const nums = raw.map((n) => Number(n)).filter((n) => Number.isFinite(n) && n > 0)
      if (nums.length === 5) return nums.map((n) => Math.min(999999, Math.floor(n * 100) / 100))
    }
  } catch (_) { /* ignore */ }
  return [...DEFAULT_CHIP_VALUES]
}
const saveChipValues = (list) => {
  try {
    localStorage.setItem(PK10_CHIP_STORAGE_KEY, JSON.stringify(list))
  } catch (_) { /* ignore */ }
}
const chipValues = ref(loadChipValues())
const chipEditOpen = ref(false)
const editChipIndex = ref(0)
const editDraft = ref('')
const chipIconAt = (i) => CHIP_ICON_LIST[i] || CHIP_ICON_LIST[0]
const displayChipValue = (i) => {
  if (chipEditOpen.value && editChipIndex.value === i) {
    return editDraft.value === '' ? '0' : editDraft.value
  }
  return chipValues.value[i]
}
const chipFaceOf = (n) => {
  const amt = Number(n) || 0
  const list = chipValues.value
  const idx = list.findIndex((c) => Number(c) === amt)
  if (idx >= 0) return CHIP_ICON_LIST[idx]
  const hit = [...list].map((c, i) => ({ c: Number(c), i })).reverse().find((x) => amt >= x.c)
  return CHIP_ICON_LIST[hit?.i ?? 0]
}

const playHelp = computed(() => getPlayHelp({
  playKey: currentPlayKey.value,
  play: play.value,
  quickSide: isPk10Quick.value ? quickSide.value : '',
  isPk10Quick: isPk10Quick.value
}))
const prizeHelpValue = computed(() => {
  if (isPk10Quick.value) {
    if (isPk10TwoSide.value || isPk10DragonTiger.value) return (1.96).toFixed(4)
    if (isPk10SumGuess.value) return Number(pk10SumOptions.value[0]?.odds || 0).toFixed(4)
    return Number(PK10_RANK_ODDS).toFixed(4)
  }
  return Number(play.value.prize || 0).toFixed(4)
})

const prizeHelpRows = computed(() => {
  if (play.value.layout !== 'sum' || !play.value.options?.length) return null
  const groups = []
  let current = null
  for (const opt of play.value.options) {
    const odds = Number(opt.odds || 0).toFixed(4)
    if (current && current.odds === odds) {
      current.nums.push(opt.num)
    } else {
      current = { odds, nums: [opt.num] }
      groups.push(current)
    }
  }
  return groups.map((g) => ({
    label: g.nums.join(','),
    value: g.odds
  }))
})

const syncRankSideSelection = (side = quickSide.value) => {
  quickRanks.value = []
  quickBets.value = []
  rankBets.value = []
  chipStakes.value = {}
}

const setQuickSide = (side) => {
  quickSide.value = side
  syncRankSideSelection(side)
  twoSideBets.value = []
  sumGuessBets.value = []
  chipOpen.value = false
  chipEditOpen.value = false
}

const draws = computed(() => {
  if (useLiveDraws.value && liveDraws.value.length) return liveDraws.value
  return isPk10.value
    ? generatePk10Draws(game.value.id, 100)
    : generateDraws({
        gameId: game.value.id,
        digitLen: getDigitLen(game.value),
        count: 100,
        group: game.value.group
      })
})
const lastCodes = computed(() => liveNear.value?.last?.codes || draws.value[0]?.codes || [9, 2, 7, 3, 8])
const lastIssue = computed(() => liveNear.value?.last?.numero || draws.value[0]?.issue || '2026215')
const nextIssue = computed(() => liveNear.value?.current?.numero || String(Number(lastIssue.value) + 1))
const historyRows = computed(() => draws.value.slice(0, 5))
const pk10Attrs = computed(() => pk10AttrSummary(lastCodes.value))

const goTrend = () => {
  const path = game.value.id === 1103 ? '/trend/tc-lhc' : '/trend'
  router.push({ path, query: { id: game.value.id } })
}

const goRoadmap = () => {
  router.push({ path: '/roadmap', query: { id: game.value.id } })
}

const goLongDragon = () => {
  router.push({ path: '/long-dragon', query: { id: game.value.id } })
}

const favPickerGames = computed(() => favPickerList())
const visibleCats = computed(() => visibleLotCats(lotCats))
const gamesByGroup = (key) => listGamesByGroup(key)

const openLotSheet = async () => {
  await syncGameVisibility()
  openAcc.value = 'fav'
  lotSheet.value = true
}

const toggleAcc = (key) => {
  openAcc.value = openAcc.value === key ? '' : key
}

const pickLottery = (id) => {
  lotSheet.value = false
  const n = Number(id)
  if (!(n > 0) || n === Number(game.value.id)) return
  setActiveGame(n)
  const path = getBetPath(n)
  router.push({ path, query: { id: n } })
}

const enterPk10Quick = () => {
  pk10View.value = 'quick'
  pk10ResultAttr.value = false
  quickSide.value = '快捷'
  syncRankSideSelection('快捷')
}

const quickPlayTip = ref(false)
const pickTip = ref('')
let quickPlayTipTimer = 0
let pickTipTimer = 0
const showQuickPlayTip = () => {
  quickPlayTip.value = true
  window.clearTimeout(quickPlayTipTimer)
  quickPlayTipTimer = window.setTimeout(() => {
    quickPlayTip.value = false
  }, 1800)
}

const showPickTip = (msg) => {
  pickTip.value = msg
  window.clearTimeout(pickTipTimer)
  pickTipTimer = window.setTimeout(() => {
    pickTip.value = ''
  }, 2200)
}

const favPlayCount = computed(() => favPlays.value.length)
const currentFavPlayKey = computed(() => currentPlayKey.value || '')
const isCurrentPlayFav = computed(() => {
  const key = currentFavPlayKey.value
  return !!key && favPlays.value.includes(key)
})
const toggleCurrentPlayFav = () => {
  const key = currentFavPlayKey.value
  if (!key) return
  toggleFavPlay(key)
}

const playGroupChildren = (group) => {
  if (!group.quick) return group.children || []
  const all = sheetMenu.value.flatMap((g) => (g.quick ? [] : (g.children || [])))
  return all.filter((item) => favPlays.value.includes(item.key))
}

const groupHasFav = (group) => {
  if (group.quick) return favPlayCount.value > 0
  return (group.children || []).some((item) => favPlays.value.includes(item.key))
}

const groupHasActive = (group) => {
  if (group.quick) return false
  if (sheetPlayMode.value !== playMode.value) return false
  if (isPk10.value && sheetPlayMode.value === 'entertainment') {
    return group.name === quickSide.value
  }
  return (group.children || []).some((item) => item.key === currentPlayKey.value)
}

const isEntJumpGroup = (group) => (
  isPk10.value
  && sheetPlayMode.value === 'entertainment'
  && !group.quick
  && pk10Sides.includes(group.name)
)

const openPlaySheet = () => {
  const modes = getPlayModes(game.value)
  sheetPlayMode.value = modes.includes('tradition') ? 'tradition' : (playMode.value || modes[0])
  const hit = sheetPlayMode.value === playMode.value
    ? sheetMenu.value.find((g) => groupHasActive(g))
    : null
  openPlayGroup.value = hit && !isEntJumpGroup(hit) ? hit.key : ''
  playSheet.value = true
  drawerJustOpened = true
  setTimeout(() => { drawerJustOpened = false }, 280)
}

const closeDrawerIfOpen = () => {
  if (playSheet.value && !drawerJustOpened) playSheet.value = false
}

const togglePlayGroup = (group) => {
  openPlayGroup.value = openPlayGroup.value === group.key ? '' : group.key
}

const onPlayGroupClick = (group) => {
  if (isEntJumpGroup(group)) {
    const item = (group.children || [])[0]
    if (item) pickPlay(item, group)
    return
  }
  togglePlayGroup(group)
}

const toggleFavPlay = (key) => {
  if (!key) return
  const i = favPlays.value.indexOf(key)
  if (i >= 0) favPlays.value.splice(i, 1)
  else favPlays.value.push(key)
  saveFavPlays()
}

const pickPlay = (item, group) => {
  playMode.value = sheetPlayMode.value
  currentPlayKey.value = item.key
  openPlayGroup.value = group.key
  playSheet.value = false
  resetPick()
  saveBetPicks()
  if (isPk10.value && playMode.value === 'entertainment') {
    enterPk10Quick()
    setQuickSide(item.name)
  }
}

const switchSheetMode = (mode) => {
  if (sheetPlayMode.value === mode) return
  sheetPlayMode.value = mode
  const hit = mode === playMode.value
    ? sheetMenu.value.find((g) => groupHasActive(g))
    : null
  openPlayGroup.value = hit && !isEntJumpGroup(hit) ? hit.key : ''
}

const togglePk10View = () => {
  pk10ResultAttr.value = !pk10ResultAttr.value
}

const betStakeOf = (key) => Number(chipStakes.value[key]) || 0

const removeChipStake = (key) => {
  if (chipStakes.value[key] == null) return
  const next = { ...chipStakes.value }
  delete next[key]
  chipStakes.value = next
}

/** 筹码条打开：累加；关闭：切换选中（金额取当前输入） */
const applyChipOrToggle = (listRef, key) => {
  const unit = Number(quickAmount.value) || 0
  if (chipOpen.value) {
    if (unit <= 0) return
    const cur = chipStakes.value[key]
    if (cur != null) {
      chipStakes.value = { ...chipStakes.value, [key]: cur + unit }
      return
    }
    chipStakes.value = { ...chipStakes.value, [key]: unit }
    if (!listRef.value.includes(key)) listRef.value.push(key)
    return
  }
  const idx = listRef.value.indexOf(key)
  if (idx >= 0) {
    listRef.value.splice(idx, 1)
    removeChipStake(key)
    return
  }
  listRef.value.push(key)
  if (unit > 0) chipStakes.value = { ...chipStakes.value, [key]: unit }
}

const toggleQuickRank = (i) => {
  const idx = quickRanks.value.indexOf(i)
  if (idx >= 0) quickRanks.value.splice(idx, 1)
  else quickRanks.value.push(i)
}

const toggleQuickBet = (key) => {
  applyChipOrToggle(quickBets, key)
}

const toggleTwoSideBet = (key) => {
  applyChipOrToggle(twoSideBets, key)
}

const toggleSumGuess = (num) => {
  applyChipOrToggle(sumGuessBets, num)
}

const rankBetKey = (rank, num) => `r${rank}-n${num}`

const isRankBetOn = (rank, num) => rankBets.value.includes(rankBetKey(rank, num))

const toggleRankBet = (rank, num) => {
  applyChipOrToggle(rankBets, rankBetKey(rank, num))
}

const clearQuick = () => {
  syncRankSideSelection(quickSide.value)
  twoSideBets.value = []
  sumGuessBets.value = []
  chipStakes.value = {}
  quickAmount.value = ''
  betPickStore()?.clear()
}

const formatBall = (n) => (isPk10.value ? String(n).padStart(2, '0') : n)
const ballClass = (i) => {
  if (isPk10.value) return 'color'
  const key = currentPlayKey.value
  // 1. P3一码/二码不定位：前3实心，后2空心
  if (key === 'p3-1d' || key === 'p3-2d') {
    return i < 3 ? 'fill' : 'outline'
  }
  // 2. P5后二直选/组选/大小单双：后2实心，前3空心
  if (
    key === 'p5-back2-zx' ||
    key === 'p5-back2-zx-ds' ||
    key === 'p5-back2-zux' ||
    key === 'p5-back2-dxds'
  ) {
    return i >= 3 ? 'fill' : 'outline'
  }
  // 3. P3后二直选 / 单式：第2、3球红底白字，其余白底红字；组选仍全空心
  if (key === 'p3-back2-zx' || key === 'p3-back2-zx-ds' || key==='p3-back2-zux') {
    return i === 1 || i === 2 ? 'fill' : 'outline'
  }
  if (key === 'p3-back2-zux') {
    return 'outline'
  }
  // 3b. P3后二大小单双：第2、3球白底红字，其余红底白字
  if (key === 'p3-back2-dxds') {
    return i === 1 || i === 2 ? 'fill' : 'outline'
  }
  // 4. 其余玩法保持原逻辑
  const fill = play.value.fillBalls ?? 3
  return i < fill ? 'fill' : 'outline'
}
const ballStyle = (n) => (isPk10.value ? { background: pk10BallColor(n) } : null)
/** P3 直选/组选和值：开奖球后显示前三位数之和 */
const lastDrawSum = computed(() => {
  if (isPk10.value || !play.value?.showDrawSum) return null
  const codes = lastCodes.value || []
  const n = Math.min(Number(play.value.fillBalls) || 3, codes.length)
  if (n <= 0) return null
  let sum = 0
  for (let i = 0; i < n; i++) sum += Number(codes[i]) || 0
  return sum
})
/** P3 相关玩法：按前三位形态显示 组二/组六/豹子；P5后二组选固定显示组二 */
const lastDrawShape = computed(() => {
  const key = currentPlayKey.value || ''
  if (key === 'p5-back2-zux') return '组二'
  // P3直选 / 直选单式：不展示形态文案
  if (key === 'p3-zx' || key === 'p3-zx-ds') return ''
  if (
    (!key.startsWith('p3-') && key !== 'front2-zux') ||
    key === 'p3-zx-sum' ||
    key === 'p3-zx-group-sum' ||
    key === 'p3-back2-zx' ||
    key === 'p3-back2-zx-ds'
  ) return ''
  const codes = (lastCodes.value || []).slice(0, 3).map((n) => Number(n))
  if (codes.length < 3 || codes.some((n) => !Number.isFinite(n))) return ''
  const uniq = new Set(codes).size
  if (uniq === 1) return '豹子'
  if (uniq === 2) return '组二'
  return '组六'
})

const selected = ref([])
const selectedSum = ref([])
const selectedSumNums = computed(() =>
  selectedSum.value
    .map((x) => Number(typeof x === 'object' ? x?.num : x))
    .filter((n) => Number.isFinite(n))
)
const gapPanelOpen = ref(false)
const missMode = ref('')
const historyOpen = ref(false)
const historyScrollRef = ref(null)
const multiple = ref(1)
const draft = ref('')
const keypadOpen = ref(false)
const balance = ref(0)
const hideBalance = ref(false)
const cartCount = ref(0)
const liveDraws = ref([])
const liveNear = ref(null)
const useLiveDraws = ref(false)
const remain = ref(periodSeconds(game.value))
let timer = 0
let drawPollTimer = 0

const syncDrawState = async (opts = {}) => {
  const gid = game.value?.id
  if (gid == null) return
  try {
    const refresh = !!opts.refresh
    const drawRes = await lgwApi.draws(gid, undefined, { refresh })
    const nearRes = await lgwApi.near(gid)
    if (nearRes.success && nearRes.data) {
      liveNear.value = nearRes.data
      if (nearRes.data.current?.remainSeconds != null) {
        remain.value = nearRes.data.current.remainSeconds
      }
    }
    const list =
      drawRes.data?.content ||
      drawRes.data?.list ||
      drawRes.content ||
      drawRes.list ||
      []
    if (drawRes.success && Array.isArray(list) && list.length) {
      liveDraws.value = list.map((row) => ({
        issue: row.numero,
        codes: row.codes || (row.winNo ? String(row.winNo).split('').map(Number) : [])
      }))
      useLiveDraws.value = true
    }
  } catch (_) {}
}

const clockText = computed(() => {
  const h = String(Math.floor(remain.value / 3600)).padStart(2, '0')
  const m = String(Math.floor((remain.value % 3600) / 60)).padStart(2, '0')
  const s = String(remain.value % 60).padStart(2, '0')
  return `${h}:${m}:${s}`
})

const missTable = computed(() =>
  positions.value.map((pos) => {
    const start = play.value.rangeStart || 0
    const r = play.value.range || 10
    const miss = {}
    for (let i = 0; i < r; i++) {
      const d = start + i
      const idx = draws.value.findIndex((row) => Number(row.codes[pos.index]) === d)
      miss[d] = idx < 0 ? draws.value.length : idx
    }
    return miss
  })
)

const hotTable = computed(() =>
  positions.value.map((pos) => {
    const start = play.value.rangeStart || 0
    const r = play.value.range || 10
    const count = {}
    for (let i = 0; i < r; i++) count[start + i] = 0
    draws.value.forEach((row) => {
      const n = Number(row.codes[pos.index])
      if (count[n] !== undefined) count[n] += 1
    })
    return count
  })
)

const matchDxds = (digit, choice) => {
  const pk10 = (play.value.rangeStart || 0) === 1 && (play.value.range || 10) === 10
  if (choice === '大') return pk10 ? digit >= 6 : digit >= 5
  if (choice === '小') return pk10 ? digit <= 5 : digit <= 4
  if (choice === '单') return digit % 2 === 1
  if (choice === '双') return digit % 2 === 0
  return false
}

const dxdsMissTable = computed(() =>
  positions.value.map((pos) => {
    const map = {}
    for (const choice of (play.value.choiceOptions || [])) {
      const idx = draws.value.findIndex((row) => matchDxds(row.codes[pos.index], choice))
      map[choice] = idx < 0 ? draws.value.length : idx
    }
    return map
  })
)

const dxdsHotTable = computed(() =>
  positions.value.map((pos) => {
    const map = {}
    for (const choice of (play.value.choiceOptions || [])) {
      map[choice] = draws.value.filter((row) => matchDxds(row.codes[pos.index], choice)).length
    }
    return map
  })
)

const betCount = computed(() => {
  if (isPk10DragonTiger.value) return twoSideBets.value.length
  if (isPk10SumGuess.value) return sumGuessBets.value.length
  if (isPk10TwoSide.value) return twoSideBets.value.length
  if (isPk10RankSide.value) return rankBets.value.length
  if (isPk10Quick.value && quickSide.value === '快捷') {
    if (!quickRanks.value.length || !quickBets.value.length) return 0
    return quickRanks.value.length * quickBets.value.length
  }
  if (isPk10Quick.value) return 0
  if (play.value.layout === 'sum' || (isPk10Ent.value && pk10View.value === 'sum')) return selectedSumNums.value.length
  if (play.value.layout === 'text') return parseTextBets().length
  // 定位胆：各位号码数相加；直选：各位都选后相乘
  if (isPositionPlay.value) {
    return selected.value.reduce((n, arr) => n + (arr?.length || 0), 0)
  }
  const rowCount = positions.value.length
  // 猜前四/五：每位至少 1 个即按各位选号数相乘（不去重拦截）
  if (isPk10FrontCombo.value) {
    for (let i = 0; i < rowCount; i++) {
      if (!selected.value[i]?.length) return 0
    }
    return selected.value.slice(0, rowCount).reduce((n, arr) => n * arr.length, 1)
  }
  for (let i = 0; i < rowCount; i++) {
    if (!selected.value[i]?.length) return 0
  }
  const minBalls = play.value.fillBalls || rowCount
  const total = selected.value.slice(0, rowCount).reduce((n, arr) => n + (arr?.length || 0), 0)
  if (total < minBalls) return 0
  if (play.value.uniqueCount ?? play.value.unique) return countUniqueDirect(selected.value, rowCount)
  return selected.value.slice(0, rowCount).reduce((n, arr) => n * arr.length, 1)
})

const allRowsFilled = computed(() => {
  const rowCount = positions.value.length
  if (!rowCount) return false
  for (let i = 0; i < rowCount; i++) {
    if (!selected.value[i]?.length) return false
  }
  return true
})

const canOfficialBet = computed(() => {
  if (isPk10Quick.value) return false
  if (play.value.layout === 'sum' || play.value.layout === 'text' || isPositionPlay.value) {
    return betCount.value > 0
  }
  // 猜前四/五：冠军…各位各选一个（可多选）即亮红
  if (isPk10FrontCombo.value) {
    return allRowsFilled.value
  }
  if (play.value.requireEachRow) {
    return allRowsFilled.value && betCount.value > 0
  }
  return betCount.value > 0
})

const countUniqueDirect = (rows, expectedRows) => {
  const totalRows = expectedRows ?? rows.length
  const walk = (i, used) => {
    if (i >= totalRows) return 1
    const row = rows[i] || []
    if (!row.length) return 0
    let n = 0
    for (const x of row) {
      if (used.has(x)) continue
      used.add(x)
      n += walk(i + 1, used)
      used.delete(x)
    }
    return n
  }
  return walk(0, new Set())
}

const liveQuickAmount = computed(() => {
  if (isPk10Quick.value && keypadOpen.value) {
    const n = parseInt(draft.value, 10)
    return n > 0 ? String(Math.min(99999, n)) : ''
  }
  return quickAmount.value
})
const canQuickBet = computed(() => betCount.value > 0 && betAmount.value > 0)

/** 仅筹码条打开时显示筹码叠放（正常投注只红底，对齐图三） */
const showChipStake = computed(() => isPk10Quick.value && chipOpen.value)

const prizeText = computed(() => {
  if (play.value.layout === 'sum' && selectedSumNums.value.length && play.value.options) {
    const picked = play.value.options.filter((o) => selectedSumNums.value.includes(o.num))
    if (picked.length) return Math.max(...picked.map((o) => o.odds))
  }
  if (isPk10Ent.value && selectedSumNums.value.length && play.value.options) {
    const picked = play.value.options.filter((o) => selectedSumNums.value.includes(o.num))
    if (picked.length) return Math.max(...picked.map((o) => o.odds))
  }
  return play.value.prize
})

const betUnit = computed(() => Number(play.value.unit) || 2)

const sumChipStakes = (keys) =>
  keys.reduce((s, k) => s + (Number(chipStakes.value[k]) || 0), 0)

const pk10ChipStakeTotal = computed(() => {
  if (isPk10DragonTiger.value || isPk10TwoSide.value) return sumChipStakes(twoSideBets.value)
  if (isPk10SumGuess.value) return sumChipStakes(sumGuessBets.value)
  if (isPk10RankSide.value) return sumChipStakes(rankBets.value)
  if (isPk10Quick.value && quickSide.value === '快捷') {
    return quickRanks.value.length * sumChipStakes(quickBets.value)
  }
  return 0
})

const betAmount = computed(() => {
  if (isPk10Quick.value) {
    // 筹码模式：按格累计；正常模式：注数 × 单价
    if (chipOpen.value) return pk10ChipStakeTotal.value
    const stakeTotal = pk10ChipStakeTotal.value
    if (stakeTotal > 0) return stakeTotal
    return betCount.value * (Number(liveQuickAmount.value) || 0)
  }
  return betCount.value * Math.max(1, Number(multiple.value) || 1) * betUnit.value
})

const toggleNum = (pi, d) => {
  const rowCount = positions.value.length
  const rows = Array.from({ length: rowCount }, (_, i) => [...(selected.value[i] || [])])
  const prev = rows[pi]
  const idx = prev.indexOf(d)
  if (idx >= 0) {
    prev.splice(idx, 1)
  } else {
    const max = play.value.maxPerRow
    if (max > 0 && prev.length >= max) {
      rows[pi] = [d]
    } else {
      prev.push(d)
      if (!play.value.choiceOptions) prev.sort((a, b) => a - b)
    }
  }
  // 猜前四/五不互斥清号；其它玩法仅在 uniquePick 时从其它位去掉同号
  if (play.value.uniquePick && !isPk10FrontCombo.value) {
    for (let ri = 0; ri < rowCount; ri++) {
      if (ri === pi) continue
      rows[ri] = rows[ri].filter((x) => x !== d)
    }
  }
  selected.value = rows
}

const applyQuick = (pi, key) => {
  const rowCount = positions.value.length
  const r = play.value.range || 10
  const rs = play.value.rangeStart || 0
  let next
  if (r > 10 || rs > 0) {
    const all = Array.from({ length: r }, (_, i) => rs + i)
    const mid = rs + Math.floor(r / 2)
    const map = { all, big: all.filter(n => n >= mid), small: all.filter(n => n < mid), odd: all.filter(n => n % 2 === 1), even: all.filter(n => n % 2 === 0), clear: [] }
    next = [...(map[key] || [])]
  } else {
    next = [...quickMap[key]]
  }
  let rows = Array.from({ length: rowCount }, (_, i) => (i === pi ? [...next] : [...(selected.value[i] || [])]))
  if (play.value.uniquePick && !isPk10FrontCombo.value && next.length) {
    const picked = new Set(next)
    rows = rows.map((row, ri) => {
      if (ri === pi || !row.length) return row
      return row.filter((x) => !picked.has(x))
    })
  }
  selected.value = rows
}

const toggleSum = (num) => {
  const base = [...selectedSumNums.value]
  const i = base.indexOf(num)
  if (i >= 0) base.splice(i, 1)
  else base.push(num)
  base.sort((a, b) => a - b)
  selectedSum.value = base
}

const applySumQuick = (key) => {
  const all = play.value.options.map((o) => o.num)
  const min = Math.min(...all)
  const max = Math.max(...all)
  const map = {
    all,
    big: all.filter((n) => n >= 12),
    small: all.filter((n) => n <= 11),
    odd: all.filter((n) => n % 2 === 1),
    even: all.filter((n) => n % 2 === 0),
    clear: []
  }
  if (play.value.sumType === 'gyj') {
    const mid = (min + max) / 2
    map.big = all.filter((n) => n > mid)
    map.small = all.filter((n) => n <= mid)
  } else if (play.value.sumType === 'sw') {
    map.big = all.filter((n) => n >= 12)
    map.small = all.filter((n) => n <= 11)
  }
  selectedSum.value = [...(map[key] || [])]
}

const mapSumSelection = () =>
  selectedSumNums.value.map((num) => {
    const opt = (play.value.options || []).find((o) => o.num === num)
    return { num, odds: Number(opt?.odds) || 0 }
  })

const textInput = ref('')
const fileInputRef = ref(null)

const parseTextBets = () => {
  if (!textInput.value.trim()) return []
  const isPk10Text = (play.value.rangeStart || 0) === 1 && (play.value.range || 10) === 10
  const count = Number(play.value.fillBalls) || play.value.positions?.length || 3
  if (isPk10Text) {
    const bets = []
    const parts = textInput.value.trim().split(/[\n\r;|；]+/)
    for (const part of parts) {
      const compact = part.replace(/[^\d]/g, '')
      if (!compact || compact.length % 2 !== 0) continue
      for (let i = 0; i + count * 2 <= compact.length; i += count * 2) {
        const slice = compact.slice(i, i + count * 2)
        const nums = []
        let ok = true
        for (let j = 0; j < count; j++) {
          const n = Number(slice.slice(j * 2, j * 2 + 2))
          if (n < 1 || n > 10 || nums.includes(n)) {
            ok = false
            break
          }
          nums.push(n)
        }
        if (ok) bets.push(nums.map((n) => String(n).padStart(2, '0')).join(''))
      }
    }
    return bets
  }
  const digits = Number(play.value.textDigits) || count
  return textInput.value.trim().split(/[\n\r,;|\s]+/)
    .map((l) => l.replace(/[+.]/g, ''))
    .filter((l) => new RegExp(`^\\d{${digits}}$`).test(l))
}

const handleFileImport = () => {
  fileInputRef.value?.click()
}

const onFileChange = (e) => {
  const file = e.target.files?.[0]
  if (!file) return
  const reader = new FileReader()
  reader.onload = (ev) => {
    textInput.value = ev.target.result
  }
  reader.readAsText(file)
  e.target.value = ''
}

const filterTextInput = () => {
  const bets = parseTextBets()
  const unique = [...new Set(bets)]
  textInput.value = unique.join('\n')
}

const resetPick = () => {
  textInput.value = ''
  selected.value = positions.value.map(() => [])
  selectedSum.value = []
  twoSideBets.value = []
  sumGuessBets.value = []
  sumGuessTab.value = 'gy'
  quickAmount.value = ''
  chipStakes.value = {}
  chipOpen.value = false
  chipEditOpen.value = false
  const pk10 = game.value?.group === 'PK10'
  quickSide.value = '快捷'
  syncRankSideSelection('快捷')
  pk10View.value = pk10 && playMode.value === 'entertainment' ? 'quick' : 'sum'
  pk10ResultAttr.value = false
  gapPanelOpen.value = false
  missMode.value = ''
  historyOpen.value = false
  multiple.value = Number(play.value.defaultMultiple) || 1
  remain.value = periodSeconds(game.value)
}

function betPickStore () {
  const id = Number(game.value?.id)
  if (!id) return null
  return usePeriodPickPersist(`bet-picks-v1-${id}`)
}

function saveBetPicks () {
  const store = betPickStore()
  if (!store) return
  store.write({
    numero: String(nextIssue.value || ''),
    selected: selected.value.map((row) => [...(row || [])]),
    selectedSum: [...(selectedSum.value || [])],
    twoSideBets: [...twoSideBets.value],
    rankBets: [...(rankBets.value || [])],
    sumGuessBets: [...sumGuessBets.value],
    quickBets: [...(quickBets.value || [])],
    quickRanks: [...(quickRanks.value || [])],
    chipStakes: { ...chipStakes.value },
    chipOpen: !!chipOpen.value,
    quickSide: quickSide.value,
    sumGuessTab: sumGuessTab.value,
    currentPlayKey: currentPlayKey.value,
    playMode: playMode.value,
    pk10View: pk10View.value,
    multiple: multiple.value,
    quickAmount: quickAmount.value
  })
}

function restoreBetPicks () {
  const store = betPickStore()
  if (!store) return
  store.restoreIfSamePeriod(nextIssue.value, (data) => {
    if (Array.isArray(data.selected)) selected.value = data.selected.map((row) => [...(row || [])])
    if (Array.isArray(data.selectedSum)) selectedSum.value = [...data.selectedSum]
    if (Array.isArray(data.twoSideBets)) twoSideBets.value = [...data.twoSideBets]
    if (Array.isArray(data.rankBets)) rankBets.value = [...data.rankBets]
    if (Array.isArray(data.sumGuessBets)) sumGuessBets.value = [...data.sumGuessBets]
    if (Array.isArray(data.quickBets)) quickBets.value = [...data.quickBets]
    if (Array.isArray(data.quickRanks)) quickRanks.value = [...data.quickRanks]
    if (data.chipStakes && typeof data.chipStakes === 'object') chipStakes.value = { ...data.chipStakes }
    if (data.quickSide) quickSide.value = data.quickSide
    if (data.sumGuessTab) sumGuessTab.value = data.sumGuessTab
    if (data.currentPlayKey) currentPlayKey.value = data.currentPlayKey
    if (data.playMode) playMode.value = data.playMode
    if (data.pk10View) pk10View.value = data.pk10View
    if (data.multiple != null) multiple.value = Number(data.multiple) || multiple.value
    if (data.quickAmount != null) quickAmount.value = String(data.quickAmount)
    const hasChip = Object.keys(chipStakes.value).length > 0
    if (hasChip || data.chipOpen) chipOpen.value = true
  })
}

const rowQuicksFor = (pi) => (pi === 0 && gapPanelOpen.value ? globalQuicks : rowQuicks)

const pickGap = (mode) => {
  missMode.value = mode
  gapPanelOpen.value = false
}

const closeGap = () => {
  missMode.value = ''
  gapPanelOpen.value = false
}

const statText = (pi, d) => {
  if (play.value.choiceOptions) {
    const row = missMode.value === 'hot' ? dxdsHotTable.value[pi] : dxdsMissTable.value[pi]
    return row?.[d] ?? 0
  }
  return missMode.value === 'hot' ? hotTable.value[pi][d] : missTable.value[pi][d]
}

const statClass = (pi, d) => {
  if (missMode.value !== 'hot') return ''
  const isDxds = !!play.value.choiceOptions
  const row = isDxds ? dxdsHotTable.value[pi] : hotTable.value[pi]
  if (!row) return ''
  const vals = isDxds ? play.value.choiceOptions.map((k) => row[k]) : Object.values(row)
  const max = Math.max(...vals)
  const min = Math.min(...vals)
  if (row[d] === max && max !== min) return 'hot'
  if (row[d] === min && max !== min) return 'cold'
  return ''
}

const changeMultiple = (delta) => {
  multiple.value = Math.min(9999, Math.max(1, (Number(multiple.value) || 1) + delta))
  if (keypadOpen.value) draft.value = String(multiple.value)
}

const openKeypad = () => {
  chipEditOpen.value = false
  chipOpen.value = false
  draft.value = isPk10Quick.value
    ? (quickAmount.value || '')
    : (multiple.value > 1 ? String(multiple.value) : '')
  keypadOpen.value = true
}

const openChipEdit = () => {
  keypadOpen.value = false
  let idx = chipValues.value.findIndex((c) => Number(c) === Number(quickAmount.value))
  if (idx < 0) idx = 0
  editChipIndex.value = idx
  editDraft.value = String(chipValues.value[idx])
  chipEditOpen.value = true
}

const closeChipEdit = () => {
  chipEditOpen.value = false
  editDraft.value = ''
}

const toggleChipEdit = () => {
  if (chipEditOpen.value) closeChipEdit()
  else openChipEdit()
}

const selectEditChip = (i) => {
  editChipIndex.value = i
  editDraft.value = String(chipValues.value[i])
  quickAmount.value = String(chipValues.value[i])
}

const applyEditDraftLive = () => {
  const raw = String(editDraft.value || '').trim()
  if (!raw || raw === '.' || raw.endsWith('.')) return false
  const n = Number(raw)
  if (!Number.isFinite(n) || n <= 0) return false
  const val = Math.min(999999, Math.round(n * 100) / 100)
  const next = [...chipValues.value]
  next[editChipIndex.value] = val
  chipValues.value = next
  quickAmount.value = String(val)
  draft.value = String(val)
  saveChipValues(next)
  return true
}

const confirmChipEdit = () => {
  applyEditDraftLive()
  closeChipEdit()
}

const pressChipKey = (key) => {
  let d = String(editDraft.value || '')
  if (key === 'clear') {
    editDraft.value = ''
    return
  }
  if (key === 'del') {
    editDraft.value = d.slice(0, -1)
    applyEditDraftLive()
    return
  }
  if (key === '.') {
    if (d.includes('.')) return
    editDraft.value = d === '' ? '0.' : `${d}.`
    return
  }
  if (!/^\d$/.test(key)) return
  if (d === '0') d = ''
  if (d.replace('.', '').length >= 6) return
  editDraft.value = `${d}${key}`
  applyEditDraftLive()
}

const toggleChipSheet = () => {
  if (keypadOpen.value) confirmKeypad()
  if (chipEditOpen.value) closeChipEdit()
  const next = !chipOpen.value
  if (next && !Number(quickAmount.value)) {
    quickAmount.value = String(chipValues.value[0])
    draft.value = String(chipValues.value[0])
  }
  chipOpen.value = next
}

const pickChip = (n) => {
  quickAmount.value = String(n)
  draft.value = String(n)
  keypadOpen.value = false
  chipEditOpen.value = false
}

const applyDraft = () => {
  const n = parseInt(draft.value, 10)
  if (isPk10Quick.value) {
    quickAmount.value = !n || n < 1 ? '' : String(Math.min(99999, n))
    return
  }
  multiple.value = !n || n < 1 ? 1 : Math.min(9999, n)
}

const hideKeypad = () => {
  applyDraft()
  keypadOpen.value = false
  chipOpen.value = false
  chipEditOpen.value = false
}

const confirmKeypad = () => {
  applyDraft()
  keypadOpen.value = false
  chipOpen.value = false
  chipEditOpen.value = false
}

const pressKey = (key) => {
  if (key === 'clear') {
    draft.value = ''
    if (isPk10Quick.value) applyDraft()
    return
  }
  if (key === 'del') {
    draft.value = draft.value.slice(0, -1)
    if (isPk10Quick.value) applyDraft()
    return
  }
  if (key === '.') return
  if (draft.value.length >= (isPk10Quick.value ? 6 : 4)) return
  draft.value += key
  if (isPk10Quick.value) applyDraft()
}

const allIn = () => {
  if (isPk10Quick.value) {
    if (!betCount.value) return
  } else if (!canOfficialBet.value) {
    return
  }
  const unit = betCount.value * betUnit.value
  multiple.value = balance.value > 0 ? Math.max(1, Math.floor(balance.value / unit)) : 1
}

const addCart = async () => {
  await submitCartItem()
}

const buildCartPayload = () => {
  const picks = positions.value.map((pos, pi) => ({
    rank: pos.index,
    name: pos.name,
    nums: [...(selected.value[pi] || [])]
  }))
  const isSumPick = play.value.layout === 'sum' || (isPk10Ent.value && !isPk10Quick.value)
  const hasConfirm = isArcherRacing.value && confirmItems.value.length > 0
  let content = ''
  if (hasConfirm) {
    content = confirmItems.value.map((it) => `${it.play} ${it.code}`).join(' / ')
  } else if (isSumPick) {
    content = `${play.value.playName} ${selectedSumNums.value.join(',')}`
  } else if (isPk10Quick.value) {
    content = `${play.value.playName || quickSide.value} ${betCount.value}注`
  } else {
    content = picks
      .filter((p) => p.nums.length)
      .map((p) => `${p.name}:${p.nums.map((n) => (isPk10.value ? padPk10Num(n) : n)).join(',')}`)
      .join(' ')
  }
  const unitAmt = hasConfirm
    ? null
    : (isPk10Quick.value
      ? (Number(liveQuickAmount.value) || 0)
      : Math.max(1, Number(multiple.value) || 1) * betUnit.value)
  const betItems = []
  if (hasConfirm) {
    confirmItems.value.forEach((it) => {
      const m = /^p(\d+)-(\d+)$/.exec(String(it.id))
      betItems.push({
        key: it.id,
        label: `${it.play} ${it.code}`,
        amount: Number(it.amount) || 0,
        odds: Number(it.odds) || 0,
        rank: m ? Number(m[1]) : undefined,
        num: m ? Number(m[2]) : undefined
      })
    })
  } else if (isPk10Quick.value) {
    collectConfirmItems().forEach((it) => {
      const id = String(it.id)
      const row = {
        key: id,
        label: `${it.play} ${it.code}`,
        amount: Number(it.amount) || 0,
        odds: Number(it.odds) || 0
      }
      const rn = /^r(\d+)-n(\d+)$/.exec(id)
      if (rn) {
        row.rank = Number(rn[1])
        row.num = Number(rn[2])
      }
      const dt = /^dt(\d+)-(dragon|tiger)$/.exec(id)
      if (dt) {
        row.key = `r${dt[1]}-${dt[2]}`
      }
      const sumM = /^sum-(\d+)$/.exec(id)
      if (sumM) {
        row.num = Number(sumM[1])
        row.sumType = sumGuessTab.value || 'gy'
      }
      const q = /^q-(\d+)-(.+)$/.exec(id)
      if (q) {
        const bet = q[2]
        if (/^n(\d+)$/.test(bet)) {
          row.rank = Number(q[1])
          row.num = Number(bet.slice(1))
        }
      }
      betItems.push(row)
    })
  } else if (isPositionPlay.value) {
    picks.forEach((p) => {
      p.nums.forEach((num) => {
        betItems.push({
          key: `p${p.rank}-${num}`,
          label: `${p.name} ${isPk10.value ? padPk10Num(num) : num}`,
          amount: unitAmt,
          odds: Number(prizeText.value) || play.value.prize || 0,
          rank: p.rank,
          num
        })
      })
    })
  } else if (isSumPick) {
    const sumType = play.value.sumType || getSumPlayType(currentPlayKey.value)
    mapSumSelection().forEach(({ num, odds }) => {
      betItems.push({
        key: `${sumType}-${num}`,
        label: `${play.value.playName} ${num}`,
        amount: unitAmt,
        odds,
        num,
        sumType
      })
    })
  } else if (isPk10.value && play.value.choiceStyle === 'dt') {
    // 传统龙虎斗：选「龙/虎」
    const rank = Number(play.value.positions?.[0]?.index ?? 0)
    ;(selected.value[0] || []).forEach((label) => {
      const side = label === '龙' || label === 'dragon' ? 'dragon' : 'tiger'
      betItems.push({
        key: `r${rank}-${side}`,
        label: `${play.value.playName} ${label}`,
        amount: unitAmt,
        odds: Number(prizeText.value) || play.value.prize || 0
      })
    })
  } else if (!isPk10.value && isPositionPlay.value === false && picks.some((p) => p.nums.length)) {
    // P3/低频直选等：把 selection 一并带上，结算端用 picks 还原
  }
  return {
    gameId: game.value.id,
    gameName: game.value.name,
    playKey: currentPlayKey.value,
    playName: isPk10Quick.value ? quickSide.value : play.value.playName,
    numero: nextIssue.value,
    count: hasConfirm ? confirmCount.value : betCount.value,
    amount: hasConfirm ? confirmAmount.value : betAmount.value,
    multiple: isPk10Quick.value ? 1 : Math.max(1, Number(multiple.value) || 1),
    unit: betUnit.value,
    odds: hasConfirm
      ? Number(confirmItems.value[0]?.odds) || 0
      : (Number(prizeText.value) || play.value.prize || 0),
    content,
    items: betItems.length ? betItems : undefined,
    selection: {
      picks,
      sum: isSumPick ? mapSumSelection() : undefined,
      quickSide: isPk10Quick.value ? quickSide.value : undefined,
      confirmItems: hasConfirm ? confirmItems.value.map((it) => ({ ...it })) : undefined
    }
  }
}

const loadPlayerSettings = async () => {
  try {
    const res = await lgwApi.playerSettings()
    if (res.success && res.data) {
      soundOn.value = res.data.soundOn !== false
      noticeOn.value = res.data.noticeOn !== false
    }
  } catch (_) {}
}

const savePlayerSettings = async (patch) => {
  try {
    await lgwApi.updatePlayerSettings(patch)
  } catch (_) {}
}

const toggleSound = async () => {
  const next = !soundOn.value
  soundOn.value = next
  await savePlayerSettings({ soundOn: next })
}

const toggleNotice = async () => {
  const next = !noticeOn.value
  noticeOn.value = next
  await savePlayerSettings({ noticeOn: next })
}

const loadAccount = async () => {
  try {
    const res = await lgwApi.account()
    if (res.success && res.data) {
      balance.value = Number(res.data.availBalance ?? res.data.balance ?? 0)
    }
  } catch {
    /* ignore */
  }
}

const loadCart = async () => {
  try {
    const res = await lgwApi.getCart()
    if (res.success && res.data) {
      cartCount.value = Number(res.data.count ?? res.data.items?.length ?? 0)
    }
  } catch {
    /* ignore */
  }
}

const placeDirectBet = async () => {
  if (isPk10Quick.value) {
    if (!canQuickBet.value) return false
  } else if (!canOfficialBet.value) {
    return false
  }
  return executeBet(
    () => lgwApi.bet(buildCartPayload()),
    {
      onSuccess: () => {
        resetPick()
        betPickStore()?.clear()
      },
      onBalanceRefresh: loadAccount
    }
  )
}

const submitCartItem = async () => {
  if (isPk10Quick.value) {
    if (!canQuickBet.value) return false
  } else if (!canOfficialBet.value) {
    return false
  }
  try {
    const res = await lgwApi.addCart(buildCartPayload())
    if (!res.success) return false
    cartCount.value = Number(res.data?.count ?? cartCount.value + 1)
    resetPick()
    return true
  } catch {
    return false
  }
}

const padPk10Num = (n) => String(n).padStart(2, '0')
const fmtOdds = (n) => Number(n || 0).toFixed(4)
const expectedWin = (item) => (Number(item.amount || 0) * Number(item.odds || 0)).toFixed(4)

const defaultConfirmAmount = () => {
  if (isPk10Quick.value) return String(Number(liveQuickAmount.value) || '')
  return String(Math.max(1, Number(multiple.value) || 1) * betUnit.value)
}

const collectConfirmItems = () => {
  const amount = defaultConfirmAmount()
  const items = []
  const push = (id, play, code, odds, stakeKey) => {
    const amt = stakeKey != null
      ? String(Number(chipStakes.value[stakeKey]) || Number(liveQuickAmount.value) || 0)
      : amount
    items.push({ id, play, code: String(code), odds: Number(odds) || 0, amount: amt })
  }

  if (isPk10RankSide.value) {
    rankBets.value.forEach((key) => {
      const m = /^r(\d+)-n(\d+)$/.exec(key)
      if (!m) return
      push(key, PK10_RANKS[Number(m[1])], padPk10Num(m[2]), PK10_RANK_ODDS, key)
    })
    return items
  }

  if (isPk10TwoSide.value) {
    twoSideBets.value.forEach((key) => {
      for (const sec of pk10TwoSides) {
        const hit = sec.items.find((it) => it.key === key)
        if (!hit) continue
        const code = hit.pair ? `${hit.pair}${hit.label}` : hit.label
        push(key, sec.title, code, hit.odds, key)
        return
      }
    })
    return items
  }

  if (isPk10DragonTiger.value) {
    twoSideBets.value.forEach((key) => {
      for (const sec of pk10DragonSections) {
        const hit = sec.items.find((it) => it.key === key)
        if (!hit) continue
        push(key, sec.title, hit.label, hit.odds, key)
        return
      }
    })
    return items
  }

  if (isPk10SumGuess.value) {
    const tab = pk10SumTabs.find((t) => t.key === sumGuessTab.value)
    sumGuessBets.value.forEach((num) => {
      const opt = pk10SumOptions.value.find((o) => o.num === num)
      push(`sum-${num}`, tab?.label || '猜和值', num, opt?.odds || 0, num)
    })
    return items
  }

  if (isPk10Quick.value && quickSide.value === '快捷') {
    quickRanks.value.forEach((rank) => {
      quickBets.value.forEach((betKey) => {
        const bet = pk10QuickBets.find((b) => b.key === betKey)
        if (!bet) return
        const code = bet.num != null ? padPk10Num(bet.num) : bet.label
        const odds = bet.num != null ? PK10_RANK_ODDS : 1.96
        push(`q-${rank}-${betKey}`, PK10_RANKS[rank], code, odds, betKey)
      })
    })
    return items
  }

  if (positions.value.length === 1) {
    (selected.value[0] || []).forEach((num) => {
      push(`p0-${num}`, play.value.playName, isPk10.value ? padPk10Num(num) : num, play.value.prize)
    })
    if (items.length) return items
  }

  if (play.value.layout === 'sum' || (isPk10Ent.value && pk10View.value === 'sum')) {
    selectedSumNums.value.forEach((num) => {
      const opt = (play.value.options || []).find((o) => o.num === num)
      push(`sum-${num}`, play.value.playName, num, opt?.odds || play.value.prize)
    })
    if (items.length) return items
  }

  // 定位胆：每位所选号码各算 1 注
  if (isPositionPlay.value) {
    positions.value.forEach((pos, pi) => {
      (selected.value[pi] || []).forEach((num) => {
        const code = isPk10.value ? padPk10Num(num) : num
        push(`p${pos.index}-${num}`, pos.name, code, play.value.prize)
      })
    })
    return items
  }

  if (betCount.value) {
    const picks = positions.value.map((pos, pi) => {
      const nums = selected.value[pi] || []
      if (!nums.length) return ''
      const text = nums.map((n) => (isPk10.value ? padPk10Num(n) : n)).join(',')
      return `${pos.name}:${text}`
    }).filter(Boolean).join(' ')
    push('all', play.value.playName, picks || `${betCount.value}注`, play.value.prize)
  }
  return items
}

const confirmCount = computed(() => confirmItems.value.length)
const confirmAmount = computed(() =>
  confirmItems.value.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
)

const onConfirmAmount = (item, e) => {
  item.amount = String(e.target.value || '').replace(/\D/g, '').slice(0, 6)
}

const removeConfirmItem = (id) => {
  confirmItems.value = confirmItems.value.filter((item) => item.id !== id)
  if (!confirmItems.value.length) closeBetConfirm()
}

const openBetConfirm = async () => {
  if (isPk10Quick.value) {
    if (!canQuickBet.value) return
  } else if (!canOfficialBet.value) {
    if (isPk10FrontCombo.value || play.value.requireEachRow) {
      const n = positions.value.length
      const label = n === 4 ? '四位' : (n === 5 ? '五位' : `${n}位`)
      if (!allRowsFilled.value) {
        showPickTip(`请${label}各至少选择一个号码`)
      } else if (!betCount.value) {
        showPickTip('请调整选号后再投注')
      }
    }
    return
  }
  if (!isArcherRacing.value && shouldSkipBetConfirm()) {
    await confirmBet()
    return
  }
  if (isArcherRacing.value) {
    confirmItems.value = collectConfirmItems()
    if (!confirmItems.value.length) return
  } else {
    confirmItems.value = []
  }
  confirmSkipToday.value = false
  betConfirmSheet.value = true
}

const closeBetConfirm = () => {
  betConfirmSheet.value = false
  confirmItems.value = []
}

const confirmBet = async () => {
  const total = isArcherRacing.value ? confirmAmount.value : betAmount.value
  if (isArcherRacing.value && !total) return
  if (!isArcherRacing.value && confirmSkipToday.value) {
    saveSkipBetConfirm()
  }
  betConfirmSheet.value = false
  if (balance.value < total) {
    confirmItems.value = []
    openBalanceTip()
    return
  }
  await placeDirectBet()
  confirmItems.value = []
}

const BET_CONFIRM_SKIP_KEY = 'bet-confirm-skip-date'
const todayTag = () => {
  const now = new Date()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  const d = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${m}-${d}`
}
const shouldSkipBetConfirm = () => {
  try {
    return localStorage.getItem(BET_CONFIRM_SKIP_KEY) === todayTag()
  } catch {
    return false
  }
}
const saveSkipBetConfirm = () => {
  try {
    localStorage.setItem(BET_CONFIRM_SKIP_KEY, todayTag())
  } catch {
    // ignore storage errors
  }
}

const refreshBalance = async () => {
  await loadAccount()
}

const openCart = () => {
  router.push({ path: '/cart', query: { id: game.value.id } })
}

watch(
  () => game.value?.id,
  async () => {
    if (game.value?.id != null) {
      playMode.value = defaultPlayMode(game.value)
      sheetPlayMode.value = playMode.value
      currentPlayKey.value = defaultPlayKey(game.value, playMode.value)
      playSheet.value = false
      resetPick()
      liveDraws.value = []
      liveNear.value = null
      useLiveDraws.value = false
      remain.value = periodSeconds(game.value)
      await syncDrawState({
        refresh: Number(game.value?.id) === 15 || Number(game.value?.id) === 19503
      })
      restoreBetPicks()
    }
  },
  { immediate: true }
)

watch(sumGuessTab, () => {
  sumGuessBets.value = []
  chipStakes.value = {}
})

/** 普通模式下改金额框时，已选注同步为新单价（筹码累加模式不覆盖） */
watch(quickAmount, (v) => {
  if (!isPk10Quick.value || chipOpen.value) return
  const unit = Number(v) || 0
  if (unit <= 0) return
  const keys = [
    ...quickBets.value,
    ...twoSideBets.value,
    ...rankBets.value,
    ...sumGuessBets.value
  ]
  if (!keys.length) return
  const next = { ...chipStakes.value }
  keys.forEach((k) => { next[k] = unit })
  chipStakes.value = next
})

onMounted(async () => {
  remain.value = periodSeconds(game.value)
  loadAccount()
  loadPlayerSettings()
  loadCart()
  // 体彩P3P5 / 澳门飞艇：进页先同步外部开奖
  await syncDrawState({
    refresh: Number(game.value?.id) === 15 || Number(game.value?.id) === 19503
  })
  restoreBetPicks()
  timer = window.setInterval(() => {
    if (remain.value > 0) {
      remain.value -= 1
    } else {
      syncDrawState({ refresh: Number(game.value?.id) === 19503 })
    }
  }, 1000)
  drawPollTimer = window.setInterval(
    () => syncDrawState(),
    Number(game.value?.id) === 19503 ? 5000 : 3000
  )
})

watch(nextIssue, (cur) => {
  const store = betPickStore()
  if (store?.clearIfPeriodChanged(cur)) {
    selected.value = positions.value.map(() => [])
    selectedSum.value = []
    twoSideBets.value = []
    sumGuessBets.value = []
    chipStakes.value = {}
    rankBets.value = []
    quickBets.value = []
  }
})

onUnmounted(() => {
  saveBetPicks()
  window.clearInterval(timer)
  window.clearInterval(drawPollTimer)
  window.clearTimeout(quickPlayTipTimer)
  window.clearTimeout(pickTipTimer)
})
</script>

<style scoped>
.page-wrap {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 480px;
  height: 100vh;
  min-height: 100vh;
  margin: 0 auto;
  background: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    'WenQuanYi Micro Hei', 'Noto Sans CJK SC', Avenir, Helvetica, Arial, sans-serif;
  color: #333;
  overflow: hidden;
  --bet-foot-space: 152px;
}

.page-main {
  position: relative;
  height: 100%;
  min-height: 0;
  padding-bottom: var(--bet-foot-space, 152px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: margin-left 0.28s ease;
}

.page-wrap.compact .page-main {
  padding-bottom: var(--bet-foot-space, 96px);
}

.issue-block {
  background: #fff;
  padding-bottom: 2px;
}

.issue-row {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 12px 10px 8px 14px;
  border: 0;
  background: #fff;
}

.issue-main {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  gap: 10px;
}

.issue-no {
  color: #666;
  font-size: 13px;
  flex-shrink: 0;
}

.issue-row.pk10 .issue-no {
  font-size: 12px;
}

.balls {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  flex: none;
}

.balls.pk10 {
  justify-content: flex-start;
  gap: 3px;
  padding: 0;
}

.balls.sm {
  gap: 4px;
  flex: none;
}

.balls.sm.pk10 {
  gap: 2px;
}

.draw-ball {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
}

.pk10 .draw-ball,
.balls.pk10 .draw-ball {
  width: 22px;
  height: 22px;
  border-radius: 5px;
  font-size: 10px;
  line-height: 22px;
  color: #fff;
  font-weight: 800;
  font-style: italic;
  flex-shrink: 0;
  -webkit-text-stroke: 0.45px #000;
  paint-order: stroke fill;
}

.draw-ball.fill {
  background: #f42c4c;
  color: #fff;
}

.draw-sum,
.draw-shape {
  margin-left: 4px;
  flex-shrink: 0;
  align-self: center;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  height: 28px;
}
.draw-ball.outline {
  background: #fff;
  color: #f42c4c;
  box-shadow: inset 0 0 0 1.5px #f42c4c;
}

.attr-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: none;
  gap: 3px;
  padding: 0;
  min-width: 0;
}

.attr-chip {
  flex-shrink: 0;
  min-width: 22px;
  height: 22px;
  padding: 0 4px;
  border-radius: 4px;
  background: #f42c4c;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}

.attr-chip.sum {
  border-radius: 50%;
  width: 22px;
  padding: 0;
}

.issue-swap {
  width: 24px;
  height: 24px;
  display: flex;
  flex-shrink: 0;
  margin: 0 2px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.issue-swap svg {
  width: 20px;
  height: 20px;
}

.issue-caret {
  width: 22px;
  height: 22px;
  margin-left: auto;
  padding: 0;
  border: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.18s;
}

.issue-caret.open {
  transform: rotate(180deg);
}

.issue-caret img {
  width: 22px;
  height: 22px;
  display: block;
}

.history-panel {
  position: relative;
  z-index: 2;
  background: #f8f8fc;
}

.history-head {
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 32px;
  padding: 7px 48px 7px 26px;
  background: #eeecf7;
  color: #5e5e5e;
  font-size: 12px;
}

.history-panel.pk10 .history-head {
  padding-right: 26px;
}

.history-h-issue {
  width: 25%;
  flex-shrink: 0;
  text-align: center;
}

.history-h-nums {
  width: 75%;
  text-align: center;
}

.history-list {
  max-height: 190px;
  overflow: auto;
  padding: 0;
  background: #f8f8fc;
  -webkit-overflow-scrolling: touch;
}

/* 体彩P3P5 等低频：可视约 3 条，上下滑看满 5 条；不受全局 220 裁切 */
.history-panel.lf-history-panel {
  max-height: none !important;
  height: auto !important;
  overflow: visible !important;
  flex-shrink: 0;
}
.history-panel.lf-history-panel .history-head {
  padding-right: 26px;
}
.lf-history-list.history-list {
  height: 156px !important; /* 3 × 52 */
  min-height: 156px !important;
  max-height: 156px !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
.lf-history-list.history-list::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
.history-item.lf-history-item {
  height: 52px;
  min-height: 52px;
  max-height: 52px;
  margin: 0;
  padding: 4px 40px 4px 12px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.history-list-spacer {
  height: 24px;
  flex-shrink: 0;
  pointer-events: none;
}

/* 澳门飞艇等 PK10：固定行高 + 可滑看全部 5 条，无滚动条 */
.history-panel.pk10 {
  flex-shrink: 0;
}
.history-panel.pk10 .history-list {
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.history-panel.pk10 .history-list::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.history-panel.pk10 .history-item {
  flex-wrap: nowrap;
  height: 40px;
  min-height: 40px;
  max-height: 40px;
  padding: 4px 0;
  box-sizing: border-box;
}
.pk10-history-spacer {
  height: 12px;
  flex-shrink: 0;
  pointer-events: none;
}

.history-item {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 34px;
  margin: 0 26px;
  padding: 7px 0;
  border-bottom: 1px solid #ddd;
  color: #5e5e5e;
  font-size: 12px;
  background: #f8f8fc;
}

.history-item:last-child {
  border-bottom: 0;
}

.history-issue {
  width: 25%;
  flex-shrink: 0;
  color: #5e5e5e;
  font-size: 12px;
  text-align: center;
}

.history-nums {
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #f42c4c;
  font-size: 15px;
  font-weight: 500;
}

.history-balls {
  width: 75%;
  justify-content: center;
  gap: 4px;
}

.history-fab {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: #f42c4c;
  box-shadow: 0 2px 6px rgba(244, 44, 76, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 5;
  padding: 0;
}

.history-fab svg {
  width: 14px;
  height: 14px;
}

.trend-side {
  position: absolute;
  right: 0;
  bottom: 38px;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 79px;
  padding: 0;
  border: 0;
  border-radius: 19px 0 0 19px;
  background: #f42c4c;
  color: #fff;
  font-size: 12px;
  line-height: 1.15;
  letter-spacing: 2px;
  writing-mode: vertical-rl;
  text-orientation: upright;
  cursor: pointer;
}

.history-panel.lf-history-panel .trend-side {
  top: 50%;
  bottom: auto;
  transform: translateY(-50%);
}

.count-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 2px 14px 12px;
  font-size: 13px;
}

.game-name {
  padding: 0;
  border: 0;
  background: none;
  color: #f42c4c;
  font-size: 13px;
  cursor: pointer;
}

.count-txt {
  color: #888;
}

.clock {
  color: #f42c4c;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
}

.play-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.play-left,
.play-right {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #f42c4c;
  font-size: 14px;
}

button.play-left {
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.play-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.play-info {
  width: 15px;
  height: 15px;
  display: block;
}

.play-right button {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: none;
  color: #f42c4c;
  font-size: 13px;
  cursor: pointer;
}

.play-right img {
  width: 13px;
  height: 13px;
}

.quick-play-tip {
  position: absolute;
  left: 50%;
  top: 46%;
  z-index: 40;
  transform: translate(-50%, -50%);
  padding: 10px 18px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.82);
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  pointer-events: none;
}

.play-tools {
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 46px;
  padding-top: env(safe-area-inset-top);
  background: #f42c4c;
}

.play-tools button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.play-tools button.off {
  opacity: 0.82;
}

.play-tools .tool-icon {
  width: 27px;
  height: 27px;
  display: block;
  flex-shrink: 0;
}

.play-tools svg {
  width: 18px;
  height: 18px;
  display: block;
}

.play-cats {
  display: flex;
  justify-content: flex-start;
  padding-left: 14px;
  background: #4a5160;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.play-cats button {
  height: 42px;
  margin-right: 22px;
  padding: 0 2px;
  border: 0;
  background: transparent;
  color: #ddd;
  font-size: 15px;
  cursor: pointer;
}

.play-cats button.on {
  position: relative;
  color: #fff;
  font-weight: 700;
  box-shadow: none;
}

.play-cats button.on::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: #fff;
}

.play-list {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.play-row,
.play-sub {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 46px;
  padding: 0 12px;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: #4a5160;
  color: #fff;
  font-size: 15px;
  text-align: left;
  cursor: pointer;
}

.play-sub {
  background: #3b414e;
  font-size: 14px;
}

.play-sub.on {
  background: #2b313c;
}

.play-heart {
  width: 14px;
  height: 14px;
  margin-right: 10px;
  flex-shrink: 0;
}

.play-heart.sm {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  cursor: pointer;
}

.play-heart img {
  width: 100%;
  height: 100%;
  display: block;
}

.play-heart svg {
  width: 100%;
  height: 100%;
  display: block;
}

.play-name {
  flex: 1;
  min-width: 0;
}

.play-name em {
  margin-left: 6px;
  font-style: normal;
  font-weight: 400;
  color: #fff;
}

.play-check {
  margin-left: 6px;
  font-style: normal;
  font-size: 16px;
  font-weight: 700;
}

.play-caret {
  width: 8px;
  height: 8px;
  border-right: 1.6px solid #c5cad3;
  border-bottom: 1.6px solid #c5cad3;
  transform: rotate(45deg);
  transition: transform 0.18s;
}

.play-caret.open {
  margin-top: 4px;
  transform: rotate(-135deg);
}

.bet-confirm-mask {
  position: fixed;
  left: 50%;
  top: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
  max-width: 480px;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-end;
}

.bet-confirm-mask.cards {
  align-items: flex-end;
  justify-content: stretch;
  padding: 0;
}

.bet-confirm-panel {
  width: 100%;
  background: #fff;
  padding: 16px 14px 0;
}

.bet-confirm-panel.cards {
  width: 100%;
  max-width: none;
  overflow: hidden;
  border-radius: 10px 10px 0 0;
  padding: 0;
}

.bet-confirm-title {
  margin: 0 0 12px;
  color: #666;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}

.bet-confirm-panel.cards .bet-confirm-title {
  margin: 0;
  padding: 12px 10px;
  background: #f3f3f3;
  font-size: 15px;
  font-weight: 400;
}

.bet-confirm-info {
  margin-bottom: 14px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #ececec;
  color: #555;
  font-size: 14px;
  line-height: 1.8;
}

.bet-confirm-info p {
  margin: 0;
}

.bet-confirm-list {
  max-height: 46vh;
  overflow-y: auto;
  padding: 10px 12px 0;
}

.bet-confirm-card {
  display: flex;
  align-items: stretch;
  gap: 0;
  margin-bottom: 8px;
  padding: 10px 0 10px 12px;
  border-radius: 6px;
  background: #ececec;
  color: #666;
  font-size: 14px;
  line-height: 1.7;
}

.bet-confirm-card-body {
  flex: 1;
  min-width: 0;
}

.bet-confirm-card-body p {
  margin: 0;
}

.bet-confirm-card-body em {
  color: #f42c4c;
  font-style: normal;
}

.bet-confirm-amt {
  display: block;
  width: 88px;
  height: 28px;
  margin: 4px 0 6px;
  padding: 0 8px;
  border: 0;
  border-radius: 4px;
  background: #fff;
  color: #333;
  font-size: 14px;
  outline: none;
}

.bet-confirm-del {
  flex-shrink: 0;
  width: 56px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.bet-confirm-del img {
  width: 28px;
  height: 34px;
  display: block;
}

.bet-confirm-total {
  margin-bottom: 4px;
  color: #f42c4c;
  font-size: 15px;
  text-align: left;
  padding: 0 2px;
}

.bet-confirm-total em {
  color: #f42c4c;
  font-style: normal;
  font-weight: 700;
}

.bet-confirm-total.cards {
  margin: 8px 0 4px;
  color: #f42c4c;
}

.bet-confirm-note {
  margin: 0 0 8px;
  color: #f42c4c;
  font-size: 12px;
  text-align: center;
}

.bet-confirm-skip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0 0 10px;
  color: #666;
  font-size: 16px;
  cursor: pointer;
}

.bet-confirm-skip input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.bet-confirm-skip .dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #cfcfcf;
  background: #fff;
  position: relative;
}

.bet-confirm-skip input:checked + .dot {
  border-color: #f42c4c;
  background: #f42c4c;
}

.bet-confirm-skip input:checked + .dot::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 2px;
  width: 4px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.bet-confirm-skip span:last-child {
  font-size: 16px;
}

.bet-confirm-panel.cards .bet-confirm-note {
  margin: 0 0 10px;
}

.bet-confirm-actions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid #e8e8e8;
}

.bet-confirm-actions button {
  height: 46px;
  border: 0;
  background: #fff;
  color: #666;
  font-size: 16px;
  cursor: pointer;
}

.bet-confirm-actions button.ok {
  background: #f42c4c;
  color: #fff;
  font-weight: 700;
}

.bet-confirm-actions button.ok:disabled {
  background: #bebebe;
  font-weight: 400;
}

.balance-tip-mask {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
}

.balance-tip-panel {
  width: 72%;
  max-width: 320px;
  overflow: hidden;
  border-radius: 10px;
  background: #2b2b2b;
}

.balance-tip-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 20px 24px;
  color: #fff;
}

.balance-tip-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin-bottom: 16px;
  border: 3px solid #8b5cf6;
  border-radius: 50%;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  font-style: italic;
  line-height: 1;
}

.balance-tip-body p {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
}

.balance-tip-ok {
  width: 100%;
  height: 46px;
  border: 0;
  background: #f42c4c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.pick-area {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #fff;
  padding: 6px 10px 20px 0;
}

.pick-area::-webkit-scrollbar {
  display: none;
}

.pick-area:not(.quick) {
  padding-bottom: calc(var(--bet-foot-space) + env(safe-area-inset-bottom, 0px));
}

.pick-area.sum {
  padding: 2px 8px 20px 0;
}

.pick-area.sum:not(.quick) {
  padding-bottom: calc(var(--bet-foot-space) + env(safe-area-inset-bottom, 0px));
}

.pick-area.quick {
  display: flex;
  padding: 0;
  min-height: 0;
  overflow: hidden;
  background: #f6f7f9;
}

.q-side {
  width: 68px;
  flex-shrink: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #eef0f3;
}

.q-side::-webkit-scrollbar {
  display: none;
}

.q-side-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 12px 2px;
  border: 0;
  background: transparent;
  color: #666;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
}

.q-side-item::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #c8c8c8;
  flex-shrink: 0;
}

.q-side-item.on {
  background: #fff;
  color: #f42c4c;
  font-weight: 700;
  box-shadow: inset 3px 0 0 #f42c4c;
}

.q-side-item.on::before {
  background: #f42c4c;
}

.q-main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background: #fff;
}

.q-main::-webkit-scrollbar {
  display: none;
}

/* 猜和值：号码区独立滚动，右侧不显示滚动条 */
.q-main.sum-guess {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.q-main.sum-guess .sum-tabs {
  flex-shrink: 0;
}
.q-main.sum-guess .q-body-scroll {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.q-main.sum-guess .q-body-scroll::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.q-tabs {
  display: flex;
  height: 36px;
  margin: 0;
  border-bottom: 1px solid #ddd;
}

.q-tab {
  flex: 1;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 0;
  border-right: 1px solid #ddd;
  border-radius: 0;
  background: #eaeaea;
  color: #ec2529;
  font-size: 14px;
  cursor: pointer;
}

.q-tab:last-child {
  border-right: 0;
}

.q-tab img {
  width: 16px;
  height: 16px;
}

.q-tab.on {
  border-color: #ddd;
  color: #ec2529;
  font-weight: 400;
}

.chart-mask {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: flex-end;
}

.chart-panel {
  width: 100%;
  max-height: 72%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 12px;
  border-bottom: 1px solid #eee;
  color: #ec2529;
  font-size: 16px;
  font-weight: 700;
}

.chart-head button {
  border: 0;
  background: none;
  color: #666;
  font-size: 14px;
}

.chart-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 10px 0;
}

.chart-sub button {
  height: 28px;
  padding: 0 10px;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: #fff;
  color: #666;
  font-size: 12px;
}

.chart-sub button.on {
  border-color: #ec2529;
  color: #ec2529;
}

.bead-wrap {
  overflow: auto;
  padding: 12px 10px 16px;
}

.bead-grid {
  display: grid;
  grid-auto-rows: 22px;
  gap: 2px;
}

.bead {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 10px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  color: #fff;
}

.bead.red {
  background: #ec2529;
}

.bead.blue {
  background: #2f7dff;
}

.chart-empty {
  padding: 40px 0;
  text-align: center;
  color: #999;
}

.dragon-list {
  overflow: auto;
  padding: 8px 10px 16px;
}

.dragon-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  margin-bottom: 6px;
  padding: 0 12px;
  border: 0;
  border-radius: 4px;
  background: #ffdddc;
  color: #333;
  font-size: 14px;
}

.dragon-row em {
  font-style: normal;
  color: #ec2529;
  font-weight: 700;
}

.q-ranks {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 6px;
  margin: 8px 8px 0;
}

.q-rank {
  box-sizing: border-box;
  height: 30px;
  border: 2px solid #ddd;
  border-radius: 2px;
  background: #fff;
  color: #555;
  font-size: 12px;
  cursor: pointer;
}

.q-rank.on {
  border-width: 3px;
  border-color: #f42c4c;
  color: #f42c4c;
}

.q-hint {
  margin: 10px 8px 8px;
  color: #f42c4c;
  font-size: 12px;
}

.sum-tabs {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 8px;
  background: #ececec;
  border-radius: 0;
  overflow: hidden;
}

.sum-tab {
  flex: 1 1 0;
  min-width: 0;
  height: 32px;
  border: 0;
  background: transparent;
  color: #666;
  font-size: 13px;
  cursor: pointer;
}

.sum-tab.on {
  background: #fff;
  color: #f42c4c;
  font-weight: 700;
}

.q-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: start;
  grid-auto-rows: 44px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  border-top: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
}

.q-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 44px;
  margin: 0;
  padding: 0;
  border: 0;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  border-radius: 0;
  background: #fff;
  color: #555;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.q-cell.word {
  font-size: 16px;
}

.q-cell.on {
  background: #f42c4c;
  color: #fff;
}

.q-sq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  -webkit-text-stroke: 0.7px #000;
  paint-order: stroke fill;
}

.rank-cell {
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0;
}

.rank-sq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 5px;
  color: #fff;
  font-size: 15px;
  font-weight: 800;
  font-style: italic;
  line-height: 1;
  flex-shrink: 0;
  -webkit-text-stroke: 0.7px #000;
  paint-order: stroke fill;
}

.rank-cell em {
  flex: none;
  min-width: 0;
  margin: 0;
  color: #888;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  text-align: left;
}

.rank-cell.on {
  background: #f42c4c;
}

.rank-cell.on em {
  color: #fff;
}

/* 筹码下注：文字保持原布局位置；筹码在文字右侧；赔率右上黄字 */
.side-cell.chip-on,
.rank-cell.chip-on,
.q-cell.chip-on {
  position: relative;
  background: #f42c4c;
  color: #fff;
}

/* 赔率视觉上移右上，但仍用占位避免文字区域被拉宽导致位移 */
.side-cell.chip-on em,
.rank-cell.chip-on em,
.q-cell.chip-on .q-odds {
  position: absolute;
  top: 3px;
  right: 5px;
  z-index: 2;
  margin: 0;
  color: #ffe566;
  font-size: 11px;
  font-weight: 600;
  font-style: normal;
  line-height: 1;
  text-align: right;
}

.side-cell.chip-on::after,
.rank-cell.chip-on::after,
.q-cell.chip-on::after {
  content: '';
  flex: 0 0 32px;
  min-width: 32px;
  height: 1px;
  visibility: hidden;
  pointer-events: none;
}

.rank-cell.chip-on::after {
  flex: 0 0 40px;
  min-width: 40px;
}

.side-cell.chip-on .side-lab,
.rank-cell.chip-on .rank-sq,
.q-cell.chip-on .q-sq {
  position: relative;
  z-index: 2;
}

.chip-stake {
  position: absolute;
  left: 58%;
  top: 50%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  transform: translate(-50%, -48%);
  pointer-events: none;
  line-height: 1;
}

.chip-stake img {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25));
}

.chip-stake i {
  font-style: normal;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.1;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.35);
}

.side-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: start;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  border-top: 1px solid #e6e6e6;
  border-left: 1px solid #e6e6e6;
}

.side-hd {
  grid-column: 1 / -1;
  box-sizing: border-box;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  background: #f3f4f6;
  color: #333;
  font-size: 13px;
  font-weight: 700;
}

.side-cell {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: 48px;
  margin: 0;
  padding: 0 10px 0 0;
  border: 0;
  border-right: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  border-radius: 0;
  background: #fff;
  color: #222;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

.side-cell.wide {
  grid-column: 1 / -1;
  justify-content: center;
  gap: 16px;
  padding: 0;
}

.side-cell.wide .side-lab {
  flex: none;
  min-width: 40px;
}

.side-lab {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 22px;
  font-weight: 800;
  line-height: 1.05;
}

.side-lab small {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}

.side-cell em {
  flex-shrink: 0;
  min-width: 32px;
  font-style: normal;
  font-size: 13px;
  font-weight: 400;
  color: #999;
  text-align: right;
}

.dt-cell {
  justify-content: center;
  gap: 10px;
  padding: 0;
}

.dt-cell .side-lab {
  flex: none;
  min-width: 0;
  font-size: 22px;
}

.dt-cell em {
  flex: none;
  min-width: 0;
  font-size: 16px;
  text-align: left;
}

.side-cell.dragon {
  color: #f42c4c;
}

.side-cell.tiger {
  color: #3b82f6;
}

.side-cell.on {
  background: #f42c4c;
  color: #fff;
}

.side-cell.on em,
.side-cell.on.dragon,
.side-cell.on.tiger {
  color: #fff;
}

.side-cell.on.chip-on em,
.rank-cell.on.chip-on em,
.q-cell.on.chip-on .q-odds {
  color: #ffe566;
}

.quick-line.sum-quick {
  justify-content: flex-end;
  padding-right: 8px;
  min-height: 36px;
}

.hot-gap {
  position: absolute;
  left: 0;
  top: 6px;
  z-index: 3;
}

.hot-gap-closed {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 38px;
  padding: 0;
  border: 1.5px solid #f42c4c;
  border-left: 0;
  border-radius: 0 6px 6px 0;
  background: #fff;
  color: #f42c4c;
  font-size: 12px;
  line-height: 1.15;
  letter-spacing: 0;
  cursor: pointer;
}

.hot-gap.active .hot-gap-closed {
  background: #f42c4c;
  color: #fff;
  letter-spacing: 1px;
}

.hot-gap-open {
  display: flex;
  width: 126px;
  height: 38px;
  border-radius: 0 6px 6px 0;
  background: #f42c4c;
  overflow: hidden;
}

.hot-gap-open button {
  flex: 1;
  padding: 0;
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}

.hot-gap-open button.on {
  font-weight: 700;
}

.quick-line {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: 38px;
  padding-right: 6px;
}

.quick-line.first {
  padding-left: 50px;
}

.quick-line.first.panel {
  padding-left: 132px;
}

.quick-line button {
  padding: 0 8px;
  border: 0;
  background: none;
  color: #999;
  font-size: 13px;
  cursor: pointer;
  position: relative;
}

.quick-line button + button::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  bottom: 4px;
  width: 1px;
  background: #ddd;
}

.quick-line.below {
  justify-content: center;
  min-height: 32px;
  padding: 2px 8px 0 32px;
}

.quick-line.below.first {
  padding-left: 50px;
}

.quick-line.below.first.panel {
  padding-left: 132px;
}

.ds-area {
  padding: 10px 12px 0;
}

.ds-box {
  position: relative;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #f3f3f3;
  padding: 10px 12px;
  min-height: 196px;
}

.ds-hint {
  position: absolute;
  inset: 10px 12px;
  pointer-events: none;
}

.ds-line {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.7;
  color: #888;
}

.ds-line-head {
  color: #666;
}

.ds-textarea {
  width: 100%;
  box-sizing: border-box;
  border: 0;
  background: transparent;
  padding: 0;
  font-size: 13px;
  line-height: 1.7;
  resize: none;
  outline: none;
  min-height: 176px;
  color: #333;
  font-family: inherit;
}

.ds-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 0 12px;
}

.ds-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: #fff;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding: 8px 24px;
}

.ds-btn-filter {
  border: 0;
  background: none;
  padding: 0;
  color: #f42c4c;
}

.ds-ico {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.ds-ico-red {
  color: #f42c4c;
}


.pos-block {
  margin-bottom: 18px;
}

.pos-block.quick-below {
  margin-bottom: 10px;
}

.pos-body {
  display: flex;
  align-items: center;
  padding-top: 4px;
}

.pos-body.first {
  padding-top: 8px;
}

/* 猜前二等：筛选栏在号码球正上方整行 */
.pos-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.pos-block.quick-over-grid .pos-body {
  align-items: center;
}
.quick-line.over-grid {
  justify-content: space-evenly;
  width: 100%;
  min-height: 30px;
  padding: 0 2px 6px;
  box-sizing: border-box;
}
.quick-line.over-grid button {
  flex: 1;
  padding: 0 4px;
  text-align: center;
}

.pos-name {
  width: 32px;
  flex-shrink: 0;
  color: #888;
  font-size: 15px;
  line-height: 1.4;
  text-align: center;
  word-break: break-all;
  letter-spacing: 2px;
}

.pos-name.tall {
  width: 22px;
  font-size: 14px;
  line-height: 1.35;
  letter-spacing: 1px;
  align-self: flex-start;
  padding-top: 18px;
  writing-mode: vertical-rl;
}

.pos-name.dxds {
  padding-top: 42px;
}

.num-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px 0;
  flex: 1;
  padding: 2px 4px 4px 0;
  justify-items: center;
}

.num-grid.cols-4 {
  grid-template-columns: repeat(4, 1fr);
  gap: 10px 0;
}

.num-grid.dxds-grid {
  padding-top: 41px;
  padding-left: 18px;
  flex: none;
  justify-items: start;
  grid-template-columns: repeat(4, 56px);
  gap: 10px 14px;
  padding-right: 0;
}

.dt-pick-area {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  min-height: 280px;
  padding: 40px 16px 60px;
}

.dt-pick-cell {
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.dt-pick-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: #fff;
  color: #333;
  font-size: 28px;
  font-weight: 700;
}

.dt-pick-cell.on .dt-pick-btn {
  background: #f42c4c;
  border-color: #f42c4c;
  color: #fff;
}

.num-cell {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.num-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: #fff;
  color: #333;
  font-size: 20px;
}

.num-cell.on .num-btn {
  background: #f42c4c !important;
  border-color: #f42c4c !important;
  color: #fff !important;
}

.odds-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background: #fff;
  line-height: 1.05;
}

.odds-btn b {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}

.odds-btn em {
  margin-top: 2px;
  font-size: 12px;
  font-style: normal;
  color: #f42c4c;
}

.num-cell.on .odds-btn {
  background: #f42c4c;
  border-color: #f42c4c;
}

.num-cell.on .odds-btn b,
.num-cell.on .odds-btn em {
  color: #fff;
}

.stat {
  font-size: 11px;
  color: #aaa;
  line-height: 1;
  min-height: 12px;
}

.num-grid.stat-corner .stat {
  position: absolute;
  top: -2px;
  right: -4px;
  z-index: 1;
  min-width: 14px;
  min-height: 0;
  padding: 0 2px;
  border-radius: 8px;
  background: #fff;
  font-size: 12px;
  line-height: 1.2;
  color: #888;
  text-align: center;
}

.stat.hot {
  color: #f42c4c;
}

.stat.cold {
  color: #3b82f6;
}

.bet-foot {
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 20;
  width: 100%;
  max-width: 480px;
  transform: translateX(-50%);
  background: #fff;
  box-shadow: 0 -1px 0 #e8e8e8;
}

.bet-foot.compact {
  background: #fff;
}

.prize-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px 0;
  background: #fff;
}

/* 官方玩法浅色：覆盖 lf-bet-shell 灰底，中间/底栏与选号区统一白色 */
.page-wrap:not(.compact):not(.night) .bet-foot,
.page-wrap:not(.compact):not(.night) .bet-foot:not(.compact),
.page-wrap:not(.compact):not(.night) .prize-row,
.page-wrap:not(.compact):not(.night) .order-info,
.page-wrap:not(.compact):not(.night) .sum-row,
.page-wrap:not(.compact):not(.night) .act-row {
  background: #fff !important;
}

.prize {
  color: #f42c4c;
  font-size: 13px;
}

.prize em {
  font-style: normal;
  font-weight: 700;
}

.limit-row {
  padding: 6px 10px 0;
  color: #f42c4c;
  font-size: 12px;
}

.order-info {
  background: #fff;
  border-top: 1px solid #d8d8d8;
}

.sum-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 34px;
  padding: 0 10px;
  color: #333;
  font-size: 13px;
  background: #fff;
  border-bottom: 1px solid #d8d8d8;
}

.sum-row .stack,
.sum-row .amount,
.sum-row em,
.balance-num {
  color: #f42c4c;
  font-style: normal;
  font-weight: 400;
}

.compact-sum {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 32px;
  padding: 0 12px;
  color: #333;
  font-size: 13px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.sum-row.three {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
}

.sum-row.three > span:first-child {
  justify-self: start;
}

.scan-btn {
  width: 22px;
  height: 22px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.scan-btn img {
  width: 16px;
  height: 16px;
  display: block;
}

.sum-row.three .balance {
  justify-self: end;
}

.balance {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
}

.stepper {
  display: flex;
  align-items: center;
  gap: 6px;
}

.stepper > button:not(.mult-box):not(.unit-btn) {
  width: 22px;
  height: 22px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: #fff;
  color: #666;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
}

.mult-box {
  min-width: 72px;
  height: 28px;
  padding: 0 8px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mult-box.on {
  background: #fff6c8;
  border-color: #e6d98a;
}

.mult-box .ph {
  color: #999;
}

.unit-btn {
  min-width: 28px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
}

.keypad {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 48px);
  gap: 0;
  padding: 0;
  background: #fff;
  border-top: 1px solid #ececec;
}

.key {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  justify-self: stretch;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: #fff;
  color: #333;
  font-size: 22px;
  cursor: pointer;
  box-sizing: border-box;
}

.key.vk-back {
  grid-column: 3;
  grid-row: 4;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #888;
}

.key.vk-back .vk-ico {
  width: 26px;
  height: 26px;
}

.vk-ico {
  width: 22px;
  height: 22px;
  display: block;
}

.side .vk-ico {
  width: 20px;
  height: 20px;
}

.side .vk-ico.ok {
  width: 22px;
  height: 22px;
}

.side {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin: 4px 6px;
  border: 0;
  border-radius: 6px;
  background: #f2f2f2;
  color: #555;
  font-size: 12px;
  cursor: pointer;
}

.side.ok {
  grid-column: 4;
  grid-row: 3 / span 2;
  margin: 4px 6px 8px;
  background: #d4f6d5;
  color: #555;
  font-size: 12px;
  font-weight: 400;
}

.ok-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #3cb54a;
  color: #fff;
  font-size: 18px;
  line-height: 28px;
  text-align: center;
}

.balance button {
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.balance img {
  width: 16px;
  height: 16px;
  display: block;
}

.act-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 8px 10px;
  background: #fff;
}

.quick-act {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px 10px;
  background: #fff;
  position: relative;
}

.quick-act.compact-foot .amt-wrap {
  margin-left: auto;
  flex: 0 0 auto;
  min-width: 0;
  gap: 6px;
}

.quick-act.compact-foot .amt-box {
  flex: 0 0 88px;
  width: 88px;
  height: 34px;
  font-size: 13px;
}

.quick-act.compact-foot .chip-btn {
  width: 22px;
  height: 22px;
}

.quick-act.compact-foot .chip-btn img {
  width: 22px;
  height: 22px;
}

.quick-act.compact-foot .act.primary {
  flex: 0 0 auto;
  width: 108px;
  height: 34px;
  min-width: 0;
  font-size: 14px;
}

.quick-act.compact-foot .trash-btn.square {
  width: 34px;
  height: 34px;
}

.trash-btn {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: none;
  cursor: pointer;
}

.trash-btn.square {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  background: #f0f0f0;
}

.trash-btn.square.active {
  background: #ffecee;
  border-color: #f42c4c;
}

.trash-btn img {
  width: 22px;
  height: 22px;
  display: block;
}

.trash-btn.square img {
  width: 17px;
  height: 21px;
  filter: grayscale(1) brightness(1.15);
}

.trash-btn.square.active img {
  filter: none;
}

.trash-btn.square:disabled {
  cursor: default;
}

.amt-wrap {
  flex: 1;
  position: relative;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.amt-wrap.chip-only {
  justify-content: flex-end;
}

.amt-box {
  flex: 0 0 88px;
  width: 88px;
  height: 36px;
  border: 0;
  border-radius: 4px;
  background: #f0f0f0;
  color: #999;
  font-size: 13px;
  text-align: left;
  padding: 0 10px;
  cursor: pointer;
}

.chip-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
}

.chip-btn.on img {
  filter: drop-shadow(0 0 4px rgba(255, 160, 40, 0.7));
}

.chip-btn img {
  width: 26px;
  height: 26px;
  display: block;
}

.pk10-chip-bar {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  padding: 10px 12px 6px;
  background: #fff;
  border: 0;
  box-sizing: border-box;
  position: relative;
  z-index: 5;
  pointer-events: none;
}

.pk10-chip-bar > * {
  pointer-events: auto;
}

.pk10-chip {
  flex: 1;
  max-width: 60px;
  aspect-ratio: 1;
  border: 0;
  border-radius: 50%;
  background: transparent;
  position: relative;
  padding: 0;
  cursor: pointer;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.28));
  transition: transform .15s ease, filter .15s ease;
}

.pk10-chip-bg {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
}

.pk10-chip-txt {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -52%);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  pointer-events: none;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
}

.pk10-chip.active {
  transform: translateY(-6px) scale(1.08);
  filter: drop-shadow(0 0 8px rgba(255, 190, 70, 0.9)) drop-shadow(0 4px 5px rgba(0, 0, 0, 0.28));
  z-index: 1;
}

.pk10-chip.editing {
  outline: 2px solid #f5a121;
  outline-offset: 1px;
}

.pk10-chip-txt.long {
  font-size: 11px;
}

.pk10-chip-edit {
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  margin: 0 0 6px 2px;
  border: 0;
  background: transparent;
  color: #333;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

.chip-pop {
  position: absolute;
  right: 0;
  bottom: 42px;
  z-index: 30;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 6px;
  padding: 8px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
}

.chip-opt {
  min-width: 52px;
  height: 28px;
  border: 1px solid #e6e6e6;
  border-radius: 14px;
  background: #f7f7f7;
  color: #333;
  font-size: 12px;
  cursor: pointer;
}

.chip-opt.on {
  border-color: #f42c4c;
  background: #ffecee;
  color: #f42c4c;
}

.amt-box.on {
  background: #fff6c8;
  border-color: #e6d98a;
  color: #333;
}

.act.grow {
  flex: 0 0 108px;
  height: 36px;
  font-size: 15px;
  background: #bebebe;
  color: #fff;
}

.bet-foot.compact .act.grow.ready,
.bet-foot.compact .act.grow:not(:disabled) {
  background: #f42c4c;
}

.cart-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  flex-shrink: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
}

.cart-icon-wrap {
  position: relative;
  display: block;
  width: 30px;
  height: 28px;
}

.cart-btn.active .cart-icon-wrap {
  width: 48px;
  height: 44px;
}

.cart-icon-wrap img {
  width: 100%;
  height: 100%;
  display: block;
}

.cart-num {
  position: absolute;
  left: 33%;
  top: 27%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50%;
  height: 42%;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  line-height: 1;
  pointer-events: none;
}

.cart-num.long {
  font-size: 11px;
}

.act {
  height: 40px;
  border: 0;
  border-radius: 4px;
  background: #bebebe;
  color: #fff;
  font-size: 15px;
  letter-spacing: 0.5px;
  cursor: pointer;
}

.act.hand {
  flex: 0 0 72px;
}

.act.add {
  flex: 1;
  min-width: 0;
}

.act.primary {
  flex: 1.15;
  min-width: 0;
}

.act:disabled {
  cursor: default;
  background: #bebebe;
  color: #fff;
}

.act:not(:disabled) {
  background: #f42c4c;
}

.act:not(:disabled):active {
  background: #d61f3d;
}

.amt-box.fill {
  color: #333;
}

.night {
  background: #2c2e35;
  color: #ddd;
}

.night .issue-block,
.night .issue-row,
.night .pick-area,
.night .hot-gap-closed {
  background: #2c2e35;
}

.night .issue-no {
  color: #bbb;
}

.night .history-head {
  background: #666;
  color: #fff;
}

.night .history-panel,
.night .history-list,
.night .history-item {
  background: #2d2d2d;
}

.night .history-h-issue,
.night .history-h-nums,
.night .history-issue {
  color: #fff;
}

.night .history-item {
  border-color: #666;
}

.night .count-txt,
.night .pos-name,
.night .quick-line button {
  color: #9aa0a8;
}

.night .play-bar {
  border-color: #3f424a;
}

.night .quick-line button + button::before {
  background: #4a4e57;
}

.night .draw-ball.outline {
  background: #2c2e35;
}

.night .num-btn {
  background: #2c2e35;
  border-color: #5a5e68;
  color: #fff;
}

.night .odds-btn {
  background: #2c2e35;
  border-color: #5a5e68;
}

.night .odds-btn b {
  color: #fff;
}

.night .dt-pick-btn {
  background: #2c2e35;
  border-color: #5a5e68;
  color: #fff;
}

.night .q-side {
  background: #32343c;
}

.night .q-side-item {
  color: #9aa0a8;
}

.night .q-side-item.on,
.night .q-main {
  background: #2c2e35;
}

.night .q-side-item.on::before {
  background: #f42c4c;
}

.night .sum-tabs {
  background: #3a3d45;
}

.night .sum-tab {
  color: #9aa0a8;
}

.night .sum-tab.on {
  background: #2c2e35;
  color: #f42c4c;
}

.night .side-hd {
  background: #32343c;
  border-color: #3f424a;
  color: #ddd;
}

.night .side-grid,
.night .side-cell {
  border-color: #3f424a;
}

.night .side-cell {
  background: #2c2e35;
  color: #ddd;
}

.night .side-cell em {
  color: #888;
}

.night .side-cell.dragon {
  color: #ff6b84;
}

.night .side-cell.tiger {
  color: #7eb6ff;
}

.night .side-cell.on,
.night .side-cell.on em,
.night .side-cell.on.dragon,
.night .side-cell.on.tiger {
  background: #f42c4c;
  color: #fff;
}

.night .side-cell.on.chip-on em,
.night .rank-cell.on.chip-on em,
.night .q-cell.on.chip-on .q-odds {
  color: #ffe566;
  background: transparent;
}

.night .q-grid {
  border-color: #3f424a;
}

.night .q-rank,
.night .q-cell {
  background: #2c2e35;
  border-color: #3f424a;
  color: #ddd;
}

.night .q-tab {
  background: #3a2c2e;
  color: #ec2529;
  border-color: #3f424a;
}

.night .q-cell.on {
  background: #f42c4c;
  color: #fff;
}

.night .bet-foot {
  background: #32343c;
  box-shadow: 0 -1px 0 #3f424a;
}

.night .prize-row {
  background: #2c2e35;
}

.night .bet-confirm-panel {
  background: #2c2e35;
}

.night .bet-confirm-title {
  background: #25272e;
  color: #bbb;
}

.night .bet-confirm-card {
  background: #3a3d45;
  color: #ccc;
}

.night .bet-confirm-amt {
  background: #25272e;
  color: #eee;
}

.night .bet-confirm-actions {
  border-color: #444;
}

.night .bet-confirm-actions button {
  background: #2c2e35;
  color: #ddd;
}

.night .order-info,
.night .sum-row,
.night .act-row,
.night .quick-act {
  background: #25272e;
  border-color: #444;
}

.night .trash-btn.square,
.night .amt-box {
  background: #3a3d45;
}

.night .chip-pop {
  background: #32343c;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.night .chip-opt {
  background: #3a3d45;
  border-color: #555;
  color: #ddd;
}

.night .trash-btn.square.active {
  background: #4a2a30;
  border-color: #f42c4c;
}

.night .trash-btn.square img,
.night .trash-btn img,
.night .bet-confirm-del img {
  filter: none !important;
  -webkit-filter: none !important;
}

.night .sum-row {
  color: #ddd;
}

.night .keypad {
  background: #2a2c32;
}

.night .key {
  background: #3a3d45;
  color: #fff;
}

.night .side {
  background: #454850;
  color: #ddd;
}

.night .mult-box,
.night .unit-btn,
.night .stepper > button:not(.mult-box):not(.unit-btn) {
  background: #3a3d45;
  border-color: #5a5e68;
  color: #ddd;
}

.night .mult-box.on {
  background: #5a5330;
  border-color: #8a7a40;
}

.lot-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 80;
  background: rgba(0, 0, 0, 0.45);
}

.lot-panel {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  max-height: 75vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  border-radius: 0;
  overflow: hidden;
}

.lot-scroll {
  overflow: auto;
  flex: 1;
  min-height: 0;
}

.lot-acc + .lot-acc .lot-head {
  border-top: 1px solid #e6e6e6;
}

.lot-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  padding: 0 40px;
  border: 0;
  background: #ececec;
  color: #333;
  font-size: 15px;
  cursor: pointer;
}

.lot-dice {
  width: 18px;
  height: 18px;
  margin-right: 4px;
}

.lot-chev {
  position: absolute;
  right: 10px;
  top: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  transition: transform 0.18s;
}

.lot-chev.open {
  transform: translateY(-50%) rotate(180deg);
}

.lot-chev svg {
  width: 22px;
  height: 22px;
}

.lot-body {
  background: #fff;
}

.lot-game {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: 0;
  background: #fff;
  color: #222;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}

.lot-game.on {
  color: #f42c4c;
}

.lot-cancel {
  flex-shrink: 0;
  width: 100%;
  height: 48px;
  border: 0;
  background: #f42c4c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.night .lot-head {
  background: #3a3d45;
  color: #ddd;
}

.night .lot-body,
.night .lot-game {
  background: #2c2e35;
  color: #ddd;
  border-color: #3f424a;
}

.night .lot-game.on {
  color: #f42c4c;
}
/* 游戏说明 mask/panel/head/tabs/body/play/prize 样式由 lf-bet-shell.css 提供 */
.rule-list {
  margin: 0;
  padding: 12px 14px 16px 32px;
}

.rule-list > li {
  margin-bottom: 8px;
}

.rule-list .sub {
  list-style: circle;
  margin-left: 4px;
}

.rule-list .red,
.play-rule .red {
  color: #f42c4c;
}

.rule-list .deduce {
  color: #f42c4c;
  margin-top: 2px;
}

.rule-list .bold,
.play-rule .bold {
  font-weight: 700;
}

.rule-list .special p {
  margin: 0 0 4px;
}

.rule-list a {
  color: #2b6de5;
  text-decoration: underline;
  word-break: break-all;
}

.fan-tan-table {
  margin: 8px 0 12px;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
  font-size: 12px;
}

.fan-tan-row {
  display: grid;
  grid-template-columns: 96px 1fr;
  border-top: 1px solid #e8e8e8;
  min-height: 32px;
}

.fan-tan-row:first-child {
  border-top: 0;
}

.fan-tan-row.head {
  background: #f5a623;
  color: #fff;
  font-weight: 600;
  border-top: 0;
}

.fan-tan-row.head .fan-lab,
.fan-tan-row.head .fan-nums {
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff;
}

.fan-tan-row.c1 {
  background: #d4e8b8;
}

.fan-tan-row.c2 {
  background: #d6e8f5;
}

.fan-tan-row.c3 {
  background: #fde4cc;
}

.fan-tan-row.c4 {
  background: #e0e0e0;
}

.fan-lab,
.fan-nums {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 4px 6px;
  box-sizing: border-box;
}

.fan-lab {
  justify-content: center;
  border-right: 1px solid #e8e8e8;
  white-space: nowrap;
}

.fan-nums {
  justify-content: space-evenly;
  gap: 2px;
}

.fan-nums span {
  flex: 1;
  text-align: center;
}

.rule-close {
  flex-shrink: 0;
  height: 48px;
  border: 0;
  border-top: 1px solid #eee;
  background: #f42c4c;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.night .rule-panel {
  background: #2c2e35;
}

.night .rule-head {
  background: #3a3d45;
  border-color: #4a4d55;
  color: #ddd;
}

.night .rule-tabs {
  background: #2c2e35;
  border-color: #4a4d55;
}

.night .rule-tabs button {
  background: #2c2e35;
  border-color: #6a6e78;
  color: #ddd;
}

.night .rule-tabs button.on {
  border-color: #5b8def;
  color: #5b8def;
}

.night .prize-tr.head {
  background: #3a3d45;
  color: #ddd;
}

.night .prize-tr {
  border-color: #444;
  color: #bbb;
}

.night .rule-body {
  color: #ddd;
}

.night .fan-tan-table {
  border-color: #4a4d55;
}

.night .fan-lab {
  border-color: #4a4d55;
}

.night .fan-tan-row {
  border-color: #4a4d55;
}

.night .fan-tan-row.head {
  background: #c4821a;
}
</style>
